// @ts-nocheck
import {
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  hexToRgb,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  bossCastImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
  warlockCastImageByOct,
  addKindImageByOct,
} from "../../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../../lobby";

import { Game } from "../game-base";

Game.prototype.drawMines = function () {
    const c = this.ctx;
    for (const m of this.mines) {
      const armed = m.arm <= 0;
      const pulse = 0.5 + 0.5 * Math.sin(m.pulse * (armed ? 8 : 3));
      c.save();
      c.translate(m.x, m.y);
      c.fillStyle = `rgba(255,93,122,${armed ? 0.25 + 0.2 * pulse : 0.12})`;
      c.beginPath(); c.arc(0, 0, SPELLS.mine.trigger, 0, TAU); c.fill();
      c.fillStyle = armed ? "#ff5d7a" : "#7a3a48";
      c.shadowColor = "#ff5d7a"; c.shadowBlur = armed ? 12 * pulse : 0;
      c.beginPath(); c.arc(0, 0, 8, 0, TAU); c.fill();
      c.restore();
    }
  }

Game.prototype.drawHealPods = function () {
    const c = this.ctx;
    const t = this.nowS;
    const me = this.human();
    for (const pod of this.healpods) {
      const spellId = pod.spellId || "bloompod";
      const sp = SPELLS[spellId] || SPELLS.bloompod;
      const col = (sp && sp.color) || "#8ef0a8";
      const spec = spellSpriteSpec(spellId);
      const prog = armTimedProg(pod);
      pod.prog = prog;
      const r = pod.r || 120;
      const pulse = 0.5 + 0.5 * Math.sin(t * (4 + prog * 3) + (pod.pulse || 0));
      const allyView = isTeammate(me, pod.team);
      const drawSz = spellSpriteDrawSz(spellId, r, prog);
      const fillCol = "#c8ffd8";
      c.save();
      c.translate(pod.x, pod.y);
      c.save();
      this.upright();
      if (!drawSpellSprite(c, spellId, prog, drawSz)) {
        c.globalCompositeOperation = "lighter";
        const coreR = 10 + prog * 8 + pulse * 3;
        c.fillStyle = rgba(col, 0.55 + 0.35 * pulse);
        c.beginPath(); c.arc(0, 0, coreR, 0, TAU); c.fill();
        c.strokeStyle = rgba("#c8ffd8", 0.7 + 0.2 * pulse);
        c.lineWidth = 2;
        for (let i = 0; i < 4; i++) {
          const a = t * 1.4 + i * (TAU / 4);
          c.beginPath();
          c.moveTo(Math.cos(a) * coreR * 0.4, Math.sin(a) * coreR * 0.4);
          c.lineTo(Math.cos(a) * (coreR + 6 + prog * 4), Math.sin(a) * (coreR + 6 + prog * 4));
          c.stroke();
        }
      }
      c.restore();
      if (allyView) {
        drawArmRangeTelegraph(c, r, prog, col, {
          fillCol, pulse, dash: [6, 5], dashOffset: -t * 18, lineW: 2.5,
        });
      }
      c.restore();
    }
  }

Game.prototype.drawArmPops = function () {
    const c = this.ctx;
    if (!this.armPops?.length) return;
    c.save();
    c.globalCompositeOperation = "lighter";
    for (const pop of this.armPops) {
      const p = clamp(pop.t / pop.life, 0, 1);
      const ease = 1 - (1 - p) * (1 - p);
      const fillR = pop.maxR * ease;
      const fade = 1 - p;
      c.save();
      c.translate(pop.x, pop.y);
      this.upright();
      const g = c.createRadialGradient(0, 0, 0, 0, 0, fillR);
      g.addColorStop(0, rgba("#ffffff", fade * 0.6));
      g.addColorStop(0.22, rgba(pop.fillCol, fade * 0.48));
      g.addColorStop(0.65, rgba(pop.color, fade * 0.22));
      g.addColorStop(1, rgba(pop.color, 0));
      c.fillStyle = g;
      c.beginPath(); c.arc(0, 0, fillR, 0, TAU); c.fill();
      c.globalAlpha = fade * 0.95;
      c.strokeStyle = pop.color;
      c.lineWidth = 8 * fade;
      c.beginPath(); c.arc(0, 0, fillR, 0, TAU); c.stroke();
      c.globalAlpha = fade * 0.65;
      c.lineWidth = 3 * fade;
      for (let i = 0; i < 8; i++) {
        const a = i * (TAU / 8) + pop.t * 3;
        c.beginPath();
        c.moveTo(Math.cos(a) * 10, Math.sin(a) * 10);
        c.lineTo(Math.cos(a) * fillR * 0.88, Math.sin(a) * fillR * 0.88);
        c.stroke();
      }
      c.restore();
    }
    c.restore();
    c.globalAlpha = 1;
  }

Game.prototype.drawEssenceWards = function () {
    const c = this.ctx;
    const t = this.nowS;
    const needMark = this.essenceCast?.k === "bloom" ? this.essenceCast?.n : null;
    for (const w of this.essenceWards || []) {
      const light = w.mark === 1;
      const col = light ? "#e8b840" : "#8040a0";
      const colSoft = light ? "#ffe8a0" : "#c080e0";
      const r = w.r || 75;
      const highlight = needMark && w.mark === needMark;
      const pulse = 0.5 + 0.5 * Math.sin(t * (highlight ? 4.5 : 2.2) + (w.pulse || 0) * 0.001);
      c.save();
      c.translate(w.x, w.y);
      const grad = c.createRadialGradient(0, 0, 0, 0, 0, r);
      grad.addColorStop(0, rgba(colSoft, (highlight ? 0.38 : 0.22) + 0.12 * pulse));
      grad.addColorStop(0.55, rgba(col, (highlight ? 0.22 : 0.12) + 0.08 * pulse));
      grad.addColorStop(1, rgba(col, 0));
      c.fillStyle = grad;
      c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
      c.globalCompositeOperation = "lighter";
      c.strokeStyle = rgba(col, (highlight ? 0.75 : 0.45) + 0.2 * pulse);
      c.lineWidth = highlight ? 3.5 : 2.5;
      c.setLineDash(highlight ? [] : [10, 8]);
      if (!highlight) c.lineDashOffset = -t * 0.04;
      c.beginPath(); c.arc(0, 0, r * (highlight ? 0.96 : 0.92), 0, TAU); c.stroke();
      c.setLineDash([]);
      if (highlight) {
        c.strokeStyle = rgba("#ffffff", 0.35 + 0.25 * pulse);
        c.lineWidth = 1.5;
        c.beginPath(); c.arc(0, 0, r * 1.05, 0, TAU); c.stroke();
      }
      c.rotate(t * 0.25);
      c.strokeStyle = rgba(colSoft, 0.55 + 0.2 * pulse);
      c.lineWidth = 1.5;
      const rr = r * 0.38;
      for (let tri = 0; tri < 2; tri++) {
        c.beginPath();
        for (let i = 0; i <= 3; i++) {
          const a = tri * Math.PI / 3 + i / 3 * TAU - Math.PI / 2;
          const x = Math.cos(a) * rr, y = Math.sin(a) * rr;
          i ? c.lineTo(x, y) : c.moveTo(x, y);
        }
        c.closePath(); c.stroke();
      }
      c.fillStyle = rgba(colSoft, 0.75 + 0.2 * pulse);
      c.beginPath(); c.arc(0, 0, 5 + 2 * pulse, 0, TAU); c.fill();
      c.restore();
    }
  }

Game.prototype.drawEssenceCastFx = function () {
    const ec = this.essenceCast;
    if (!ec?.k || ec.ph === "recover") return;
    const c = this.ctx;
    const cx = 0, cy = -80;
    const t = this.nowS;
    const pulse = 0.5 + 0.5 * Math.sin(t * 3.2);

    if (ec.k === "meridian" && ec.an != null) {
      const angle = ec.an;
      const reach = (this.platformRadius || 950) * 1.15;
      c.save();
      c.globalCompositeOperation = "lighter";
      const dx = Math.cos(angle), dy = Math.sin(angle);
      const tx = -dy, ty = dx;
      const fillHalf = (sign, col, alpha) => {
        const s = sign >= 0 ? 1 : -1;
        c.fillStyle = rgba(col, alpha);
        c.beginPath();
        c.moveTo(cx + dx * reach * s, cy + dy * reach * s);
        c.lineTo(cx + dx * reach * s + tx * reach * 2, cy + dy * reach * s + ty * reach * 2);
        c.lineTo(cx - dx * reach * s + tx * reach * 2, cy - dy * reach * s + ty * reach * 2);
        c.lineTo(cx - dx * reach * s, cy - dy * reach * s);
        c.closePath();
        c.fill();
      };
      fillHalf(1, "#e8b840", 0.1 + 0.06 * pulse);
      fillHalf(-1, "#8040a0", 0.1 + 0.06 * pulse);
      c.strokeStyle = rgba("#ffffff", 0.35 + 0.2 * pulse);
      c.lineWidth = 3;
      c.beginPath();
      c.moveTo(cx - dx * reach, cy - dy * reach);
      c.lineTo(cx + dx * reach, cy + dy * reach);
      c.stroke();
      c.restore();
      return;
    }
  }

Game.prototype.drawBloomRipples = function () {
    if (!this.bloomRipples?.length) return;
    const c = this.ctx;
    c.save();
    c.globalCompositeOperation = "lighter";
    for (const rip of this.bloomRipples) {
      const p = clamp(rip.t / rip.life, 0, 1);
      const ease = 1 - (1 - p) * (1 - p);
      const r = rip.maxR * ease;
      const light = rip.kind === "light";
      const core = light ? "#ffe8a8" : "#c898ff";
      const mid = light ? "#e8b840" : "#8040a0";
      const fade = (1 - p) * (1 - p * 0.35);
      c.globalAlpha = fade * 0.22;
      c.strokeStyle = mid;
      c.lineWidth = 14;
      c.beginPath(); c.arc(rip.x, rip.y, r, 0, TAU); c.stroke();
      c.globalAlpha = fade * 0.55;
      c.strokeStyle = core;
      c.lineWidth = 2.5;
      c.beginPath(); c.arc(rip.x, rip.y, r, 0, TAU); c.stroke();
      c.globalAlpha = fade * 0.18;
      c.strokeStyle = core;
      c.lineWidth = 1;
      c.beginPath(); c.arc(rip.x, rip.y, r * 0.92, 0, TAU); c.stroke();
    }
    c.restore();
    c.globalAlpha = 1;
  }

/** Gold/void link beam between Morwenna and Lys during Essence Bloom / Meridian. */
Game.prototype.essenceSisterTorsoY = function (p) {
    return p.y - p.radius * 3.0;
  };

Game.prototype.drawEssenceSisterLinkBeam = function () {
    const ec = this.essenceCast;
    if (!ec?.k || ec.ph === "recover") return;
    let morwenna, lys;
    for (const p of this.players) {
      if (!p.alive || p.falling || !p.boss) continue;
      if (p.boss === "morwenna") morwenna = p;
      else if (p.boss === "lys") lys = p;
    }
    if (!morwenna || !lys) return;

    const c = this.ctx;
    const t = this.nowS;
    const pulse = 0.5 + 0.5 * Math.sin(t * 6);
    const cast = this.essenceCastProgress?.();
    const prog = cast?.prog ?? 0.5;
    const intensity = clamp(0.5 + pulse * 0.25 + prog * 0.35, 0, 1);

    const x0 = morwenna.x, y0 = this.essenceSisterTorsoY(morwenna);
    const x1 = lys.x, y1 = this.essenceSisterTorsoY(lys);
    const mx = (x0 + x1) * 0.5, my = (y0 + y1) * 0.5;
    const dx = x1 - x0, dy = y1 - y0;

    c.save();
    c.globalCompositeOperation = "lighter";
    c.lineCap = "round";

    const strokeHalf = (ax, ay, bx, by, colOuter, colInner, wOut, wIn, a) => {
      c.strokeStyle = rgba(colOuter, a * 0.35);
      c.lineWidth = wOut;
      c.beginPath(); c.moveTo(ax, ay); c.lineTo(bx, by); c.stroke();
      c.strokeStyle = rgba(colInner, a * 0.8);
      c.lineWidth = wIn;
      c.beginPath(); c.moveTo(ax, ay); c.lineTo(bx, by); c.stroke();
    };

    const wOut = 18 + prog * 14 + pulse * 6;
    const wIn = 6 + prog * 5 + pulse * 2;
    strokeHalf(x0, y0, mx, my, "#e8b840", "#ffe8a0", wOut, wIn, intensity);
    strokeHalf(x1, y1, mx, my, "#8040a0", "#ddb8ff", wOut, wIn, intensity);

    const knotR = 10 + prog * 8 + pulse * 4;
    const knot = c.createRadialGradient(mx, my, 0, mx, my, knotR * 2.4);
    knot.addColorStop(0, rgba("#ffffff", 0.9 * intensity));
    knot.addColorStop(0.32, rgba("#ffe8a0", 0.55 * intensity));
    knot.addColorStop(0.68, rgba("#c080e0", 0.48 * intensity));
    knot.addColorStop(1, rgba("#000000", 0));
    c.fillStyle = knot;
    c.beginPath(); c.arc(mx, my, knotR * 2.4, 0, TAU); c.fill();

    for (const [sister, col] of [[morwenna, "#e8b840"], [lys, "#8040a0"]]) {
      const sx = sister.x, sy = this.essenceSisterTorsoY(sister);
      const g = c.createRadialGradient(sx, sy, 0, sx, sy, sister.radius * 2.8);
      g.addColorStop(0, rgba(col, 0.55 * intensity));
      g.addColorStop(1, rgba(col, 0));
      c.fillStyle = g;
      c.beginPath(); c.arc(sx, sy, sister.radius * 2.8, 0, TAU); c.fill();
    }

    c.fillStyle = rgba("#ffffff", 0.7 * intensity);
    for (let i = 0; i < 5; i++) {
      const phase = (t * 1.6 + i * 0.18) % 1;
      c.beginPath();
      c.arc(x0 + dx * phase, y0 + dy * phase, 2 + pulse * 2, 0, TAU);
      c.fill();
    }

    c.restore();
  };

Game.prototype.drawSigils = function () {
    const c = this.ctx;
    const t = this.nowS;
    for (const sg of this.sigils) {
      if (sg.spellId === "gravity") {
        if (sg.nullSphere) { this.drawNullSphere(c, sg, t); continue; }
        this.drawBlackHole(c, sg, t); continue;
      }
      if (sg.spellId === "voidrip") { this.drawVoidRip(c, sg, t); continue; }
      if (sg.spellId === "boss_fissure") { this.drawBossFissure(c, sg, t); continue; }
      if (sg.spellId === "boss_divine_well") { this.drawDivineWell(c, sg, t); continue; }
      if (sg.spellId === "boss_solar_well") { this.drawEclipseWell(c, sg, t); continue; }
      const armed = sg.arm <= 0;
      const col = sg.spellId ? (spellInfo(sg.spellId) || {}).color || "#b98bff" : "#b98bff";
      const r = sg.r || 72;
      const pulse = 0.5 + 0.5 * Math.sin(t * (armed ? 5 : 2.5) + (sg.pulse || 0));
      c.save();
      c.translate(sg.x, sg.y);
      // filled zone tint
      c.fillStyle = rgba(col, armed ? 0.10 + 0.07 * pulse : 0.05);
      c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
      // outer boundary ring
      c.globalCompositeOperation = "lighter";
      c.strokeStyle = rgba(col, armed ? 0.5 + 0.3 * pulse : 0.25);
      c.lineWidth = armed ? 3 : 2;
      c.beginPath(); c.arc(0, 0, r, 0, TAU); c.stroke();
      // rotating rune: two triangles forming a star + inner circle
      c.rotate(t * (armed ? 0.9 : 0.35));
      c.strokeStyle = rgba(col, armed ? 0.85 : 0.4);
      c.lineWidth = 2;
      const rr = r * 0.55;
      for (let tri = 0; tri < 2; tri++) {
        c.beginPath();
        for (let i = 0; i <= 3; i++) {
          const a = tri * Math.PI / 3 + i / 3 * TAU - Math.PI / 2;
          const x = Math.cos(a) * rr, y = Math.sin(a) * rr;
          i ? c.lineTo(x, y) : c.moveTo(x, y);
        }
        c.closePath(); c.stroke();
      }
      c.beginPath(); c.arc(0, 0, rr * 0.5, 0, TAU); c.stroke();
      // bright core when armed
      if (armed) {
        c.fillStyle = rgba(col, 0.6 + 0.3 * pulse);
        c.beginPath(); c.arc(0, 0, 4 + 2 * pulse, 0, TAU); c.fill();
      }
      c.restore();
    }
  }

Game.prototype.drawBossFissure = function (c, sg, t) {
    const armed = sg.arm <= 0;
    const r = sg.r || 98;
    const open = armed ? 1 : 0.16 + 0.1 * Math.sin(t * 5 + (sg.pulse || 0));
    const pulse = 0.5 + 0.5 * Math.sin(t * (armed ? 4 : 2) + (sg.pulse || 0));
    const coreR = r * (0.24 + 0.18 * open);

    c.save();
    c.translate(sg.x, sg.y);

    const grad = c.createRadialGradient(0, 0, 0, 0, 0, coreR);
    grad.addColorStop(0, `rgba(255,120,40,${0.55 + 0.25 * open})`);
    grad.addColorStop(0.45, `rgba(80,28,8,${0.75 * open})`);
    grad.addColorStop(1, "rgba(0,0,0,0)");
    c.fillStyle = grad;
    c.beginPath(); c.arc(0, 0, coreR, 0, TAU); c.fill();

    const outerR = r * 1.05;
    const lipR = r * (0.52 + 0.38 * open);
    const lineN = armed ? 18 : 10;
    c.lineCap = "round";
    for (let i = 0; i < lineN; i++) {
      const baseA = (i / lineN) * TAU + sg.pulse * 0.2;
      const drift = (t * (armed ? 2.2 : 1) + i * 0.31) % 1;
      const startR = outerR * (0.92 + 0.06 * Math.sin(i * 3.7 + t));
      const endR = lipR * (0.55 + 0.35 * (1 - drift));
      const bow = armed ? 0.1 : 0.05;
      const x0 = Math.cos(baseA) * startR, y0 = Math.sin(baseA) * startR;
      const x1 = Math.cos(baseA - bow) * endR, y1 = Math.sin(baseA - bow) * endR;
      const midR = (startR + endR) * 0.42;
      const cx = Math.cos(baseA - bow * 0.5) * midR;
      const cy = Math.sin(baseA - bow * 0.5) * midR;
      c.globalAlpha = open * (armed ? 0.25 + 0.4 * (1 - drift) : 0.12);
      c.strokeStyle = armed ? "rgba(58,42,28,0.95)" : "rgba(42,32,22,0.65)";
      c.lineWidth = armed ? 2.4 : 1.2;
      c.beginPath();
      c.moveTo(x0, y0);
      c.quadraticCurveTo(cx, cy, x1, y1);
      c.stroke();
    }

    const segs = 14;
    c.globalAlpha = open * (armed ? 0.55 + 0.2 * pulse : 0.28);
    c.beginPath();
    for (let i = 0; i <= segs; i++) {
      const a = (i / segs) * TAU;
      const wobble = Math.sin(a * 5 + sg.pulse * 3 + t * 2) * lipR * 0.14;
      const rr = lipR + wobble;
      const x = Math.cos(a) * rr, y = Math.sin(a) * rr;
      i ? c.lineTo(x, y) : c.moveTo(x, y);
    }
    c.closePath();
    c.strokeStyle = "rgba(90,68,48,0.9)";
    c.lineWidth = armed ? 3.5 : 2;
    c.stroke();

    if (armed) {
      c.globalCompositeOperation = "lighter";
      c.globalAlpha = 0.35 + 0.25 * pulse;
      c.strokeStyle = "#ffb060";
      c.lineWidth = 2;
      c.beginPath(); c.arc(0, 0, coreR * 0.85, 0, TAU); c.stroke();
    }

    c.globalAlpha = 1;
    c.globalCompositeOperation = "source-over";
    c.restore();
  }

Game.prototype.drawDivineWell = function (c, sg, t) {
    const armed = sg.arm <= 0;
    const r = sg.r || 130;
    const pulse = 0.5 + 0.5 * Math.sin(t * (armed ? 4 : 2) + (sg.pulse || 0));
    const col = "#ff7a2f";
    c.save();
    c.translate(sg.x, sg.y);
    c.fillStyle = rgba(col, armed ? 0.14 + 0.1 * pulse : 0.07);
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
    c.globalCompositeOperation = "lighter";
    c.strokeStyle = rgba(col, armed ? 0.6 + 0.25 * pulse : 0.32);
    c.lineWidth = armed ? 4 : 2.5;
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.stroke();
    c.rotate(t * (armed ? -1.2 : -0.4));
    for (let i = 0; i < 3; i++) {
      c.strokeStyle = rgba(armed ? "#ffb060" : "#ff8844", armed ? 0.4 + 0.22 * pulse : 0.2);
      c.lineWidth = 2;
      c.beginPath();
      c.arc(0, 0, r * (0.35 + i * 0.18), i * 0.8, i * 0.8 + Math.PI * 1.2);
      c.stroke();
    }
    if (armed) {
      c.fillStyle = rgba("#ffd479", 0.55 + 0.3 * pulse);
      c.beginPath(); c.arc(0, 0, 6 + 3 * pulse, 0, TAU); c.fill();
    }
    c.restore();
  }

Game.prototype.drawEclipseWell = function (c, sg, t) {
    const armed = sg.arm <= 0;
    const r = sg.r || 115;
    const pulse = 0.5 + 0.5 * Math.sin(t * (armed ? 5 : 2.5) + (sg.pulse || 0));
    const voidCol = "#7a4fd8";
    const sunCol = "#ffc040";
    c.save();
    c.translate(sg.x, sg.y);
    c.fillStyle = rgba(voidCol, armed ? 0.16 + 0.1 * pulse : 0.08);
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
    c.globalCompositeOperation = "lighter";
    c.strokeStyle = rgba(voidCol, armed ? 0.55 + 0.25 * pulse : 0.3);
    c.lineWidth = armed ? 3.5 : 2;
    c.beginPath(); c.arc(0, 0, r, 0, TAU); c.stroke();
    c.rotate(t * (armed ? 1.4 : 0.5));
    for (let i = 0; i < 4; i++) {
      const a = i * Math.PI / 2;
      c.strokeStyle = rgba(sunCol, armed ? 0.35 + 0.2 * pulse : 0.15);
      c.lineWidth = 2;
      c.beginPath();
      c.arc(0, 0, r * (0.42 + (i % 2) * 0.12), a, a + Math.PI * 0.85);
      c.stroke();
    }
    if (armed) {
      c.fillStyle = rgba(sunCol, 0.5 + 0.35 * pulse);
      c.beginPath(); c.arc(0, 0, 5 + 2.5 * pulse, 0, TAU); c.fill();
      c.fillStyle = rgba(voidCol, 0.85);
      c.beginPath(); c.arc(r * 0.12, 0, 4 + pulse, 0, TAU); c.fill();
    }
    c.restore();
  }

Game.prototype.drawBlackHole = function (c, sg, t) {
    const col = "#b06bff";
    const r = sg.r || 280;
    const armed = sg.arm <= 0;
    const coreR = Math.min(64, r * 0.22);
    const pulse = 0.5 + 0.5 * Math.sin(t * (armed ? 6 : 3) + (sg.pulse || 0));

    c.save();
    c.translate(sg.x, sg.y);
    // pull-zone boundary + a couple of inner rings (reads as a gravity gradient)
    c.globalCompositeOperation = "lighter";
    c.strokeStyle = col; c.lineWidth = 2;
    for (let i = 1; i <= 4; i++) {
      c.globalAlpha = (armed ? 0.14 : 0.07) * (1.2 - i / 5);
      c.beginPath(); c.arc(0, 0, r * (i / 4), 0, TAU); c.stroke();
    }
    c.globalAlpha = 1;
    // accretion swirl spiralling into the core
    c.save();
    c.rotate(t * (armed ? 1.6 : 0.6));
    c.strokeStyle = col; c.lineWidth = 3;
    for (let k = 0; k < 3; k++) {
      c.globalAlpha = armed ? 0.8 : 0.4;
      c.beginPath();
      for (let i = 0; i <= 24; i++) {
        const f = i / 24, a = k * TAU / 3 + f * Math.PI * 2.4, rr = coreR * (1.7 - f * 1.2);
        const x = Math.cos(a) * rr, y = Math.sin(a) * rr;
        i ? c.lineTo(x, y) : c.moveTo(x, y);
      }
      c.stroke();
    }
    c.restore();
    c.restore();

    // dark core in normal blend so the void actually reads as black
    c.save();
    c.translate(sg.x, sg.y);
    const grad = c.createRadialGradient(0, 0, 0, 0, 0, coreR);
    grad.addColorStop(0, "#000000");
    grad.addColorStop(0.7, "#080312");
    grad.addColorStop(1, rgba(col, 0));
    c.fillStyle = grad;
    c.beginPath(); c.arc(0, 0, coreR, 0, TAU); c.fill();
    // bright event-horizon rim
    c.globalCompositeOperation = "lighter";
    c.strokeStyle = rgba(col, armed ? 0.7 + 0.3 * pulse : 0.4);
    c.lineWidth = armed ? 3 : 2;
    c.beginPath(); c.arc(0, 0, coreR * 0.55, 0, TAU); c.stroke();
    c.restore();

    // motes streaming inward toward the core (only once armed + while playing)
    if (armed && this.state === "playing" && Math.random() < 0.6) {
      const a = Math.random() * TAU, rr = r * (0.55 + 0.45 * Math.random());
      const sp = rand(140, 280);
      this.particles.push(new Particle(
        sg.x + Math.cos(a) * rr, sg.y + Math.sin(a) * rr,
        -Math.cos(a) * sp, -Math.sin(a) * sp,
        rand(0.3, 0.6), col, rand(1.4, 3), { kind: "glow", drag: 1 }));
    }
  }

Game.prototype.drawNullSphere = function (c, sg, t) {
    const r = sg.r || 280;
    const armed = sg.arm <= 0;
    const pulse = 0.5 + 0.5 * Math.sin(t * 7 + (sg.pulse || 0));
    if (armed) {
      this.drawNullSphereVacuum(c, sg.x, sg.y, r, t, pulse, sg.consumed || 0);
    } else {
      const open = 0.16 + 0.1 * Math.sin(t * 5 + (sg.pulse || 0));
      c.save();
      c.translate(sg.x, sg.y);
      c.globalCompositeOperation = "lighter";
      c.strokeStyle = "#9ad4ff";
      c.globalAlpha = open * 0.35;
      c.beginPath(); c.arc(0, 0, r * 0.35, 0, TAU); c.stroke();
      c.restore();
    }
  }

Game.prototype.drawShockwaves = function () {
    const c = this.ctx;
    c.save();
    c.globalCompositeOperation = "lighter";
    for (const w of this.shockwaves) {
      const p = clamp(w.t / w.life, 0, 1);
      const r = lerp(w.r0, w.r1, 1 - (1 - p) * (1 - p)); // ease-out expansion
      const a = (1 - p) * (w.glow ? 0.7 : 0.5);
      c.globalAlpha = a;
      c.strokeStyle = w.color;
      c.lineWidth = w.width * (1 - p * 0.6);
      c.beginPath(); c.arc(w.x, w.y, r, 0, TAU); c.stroke();
    }
    c.restore();
    c.globalAlpha = 1;
  }

Game.prototype.updateColossusChargeTrails = function (dt) {
    if (!this.chargeStamps) this.chargeStamps = [];
    for (const p of this.players) {
      if (!p.alive || p.falling || p.dashSpell !== "boss_colossus_charge") continue;
      p._chargeStampAcc = (p._chargeStampAcc || 0) + dt;
      if (p._chargeStampAcc < 0.03) continue;
      p._chargeStampAcc = 0;
      this.chargeStamps.push({
        x: p.x, y: p.y, facing: p.facing, r: p.radius * 1.05,
        t: 0, life: 0.5,
      });
      const bx = -Math.cos(p.facing), by = -Math.sin(p.facing);
      for (let i = 0; i < 4; i++) {
        this.particles.push(new Particle(
          p.x + bx * p.radius * 0.5 + rand(-10, 10),
          p.y + by * p.radius * 0.5 + rand(-10, 10),
          bx * rand(30, 110) + rand(-20, 20), by * rand(30, 110) + rand(-20, 20),
          rand(0.3, 0.55), i % 2 ? "#8a7860" : "#b8a888", rand(3, 7),
          { kind: "smoke", grav: -25, drag: 0.87 }
        ));
      }
    }
    this.chargeStamps = this.chargeStamps.filter(s => (s.t += dt) < s.life);
  }

Game.prototype.drawChargeStamps = function () {
    const c = this.ctx;
    if (!this.chargeStamps?.length) return;
    for (const s of this.chargeStamps) {
      const a = 1 - s.t / s.life;
      const fx = Math.cos(s.facing), fy = Math.sin(s.facing);
      const bx = s.x - fx * s.r * 0.75;
      const by = s.y - fy * s.r * 0.75;
      c.save();
      c.globalAlpha = a * 0.6;
      c.translate(bx, by);
      c.rotate(s.facing);
      c.fillStyle = `rgba(120,100,80,${a * 0.45})`;
      c.beginPath();
      c.ellipse(0, 0, s.r * 1.45, s.r * 0.62, 0, 0, TAU);
      c.fill();
      c.strokeStyle = `rgba(200,175,130,${a * 0.35})`;
      c.lineWidth = 2;
      c.stroke();
      c.restore();
    }
    c.globalAlpha = 1;
  }

Game.prototype.drawColossusChargeFront = function (c, p, tint) {
    const fx = Math.cos(p.facing), fy = Math.sin(p.facing);
    const px = -fy, py = fx;
    const r = p.radius;
    const tt = this.nowS;
    const pulse = 0.88 + 0.12 * Math.sin(tt * 24);
    const front = r * 2.8 * pulse;
    const back = r * 0.3;
    const halfW = r * 1.4;
    const plague = p.dashSpell === "boss_trample";
    const arcane = tint != null && !plague;
    c.save();
    c.globalCompositeOperation = "lighter";
    const g = c.createLinearGradient(fx * back, fy * back, fx * front, fy * front);
    if (plague) {
      g.addColorStop(0, "rgba(60,80,24,0.14)");
      g.addColorStop(0.45, "rgba(106,138,48,0.38)");
      g.addColorStop(1, "rgba(200,208,64,0.58)");
    } else if (arcane) {
      g.addColorStop(0, "rgba(100,60,180,0.12)");
      g.addColorStop(0.45, "rgba(160,100,240,0.32)");
      g.addColorStop(1, "rgba(220,160,255,0.52)");
    } else {
      g.addColorStop(0, "rgba(160,140,110,0.12)");
      g.addColorStop(0.45, "rgba(210,190,150,0.32)");
      g.addColorStop(1, "rgba(255,240,200,0.52)");
    }
    c.fillStyle = g;
    c.beginPath();
    c.moveTo(fx * back - px * halfW * 0.55, fy * back - py * halfW * 0.55);
    c.lineTo(fx * front + px * halfW, fy * front + py * halfW);
    c.lineTo(fx * front - px * halfW, fy * front - py * halfW);
    c.closePath();
    c.fill();
    c.strokeStyle = plague
      ? `rgba(200,208,64,${0.55 + 0.3 * Math.sin(tt * 20)})`
      : arcane
        ? `rgba(200,140,255,${0.55 + 0.3 * Math.sin(tt * 20)})`
        : `rgba(255,225,170,${0.55 + 0.3 * Math.sin(tt * 20)})`;
    c.lineWidth = plague ? 4 : 3.5;
    c.beginPath();
    c.moveTo(fx * front + px * halfW, fy * front + py * halfW);
    c.lineTo(fx * front - px * halfW, fy * front - py * halfW);
    c.stroke();
    c.strokeStyle = plague ? "rgba(106,138,48,0.42)" : arcane ? "rgba(180,120,255,0.32)" : "rgba(255,200,120,0.32)";
    c.lineWidth = 1.5;
    for (let i = -1; i <= 1; i++) {
      const off = i * halfW * 0.38;
      c.beginPath();
      c.moveTo(fx * back + px * off, fy * back + py * off);
      c.lineTo(fx * front * 0.88 + px * off * 0.45, fy * front * 0.88 + py * off * 0.45);
      c.stroke();
    }
    if (plague) {
      for (let i = 0; i < 4; i++) {
        const dro = (tt * 3 + i * 1.4) % 1;
        const dx = fx * front * (0.4 + dro * 0.5) + px * (i - 1.5) * halfW * 0.25;
        const dy = fy * front * (0.4 + dro * 0.5) + py * (i - 1.5) * halfW * 0.25;
        c.fillStyle = `rgba(200,208,64,${0.35 * (1 - dro)})`;
        c.beginPath();
        c.arc(dx, dy, r * 0.12, 0, TAU);
        c.fill();
      }
    }
    c.restore();
  }

Game.prototype.beamPoints = function (b) {
    const dx = b.x1 - b.x0, dy = b.y1 - b.y0, dist = len(dx, dy) || 1;
    const ux = dx / dist, uy = dy / dist, px = -uy, py = ux;
    const segs = Math.max(4, Math.round(dist / 42));
    const pts = [];
    for (let i = 0; i <= segs; i++) {
      const f = i / segs;
      const env = Math.sin(f * Math.PI);
      const jit = (Math.sin(b.seed + i * 12.9 + b.t * 90) + Math.sin(b.seed * 1.7 + i * 4.1)) * 9 * env;
      pts.push([b.x0 + dx * f + px * jit, b.y0 + dy * f + py * jit]);
    }
    return pts;
  }

Game.prototype.drawVoidBeam = function (c, b) {
    const a = clamp(1 - b.t / b.life, 0, 1);
    const pts = this.beamPoints(b);
    const wScale = b.width > 0 ? b.width / 24 : 1;
    const chargeVis = clamp((b.width - 20) / 72, 0.06, 1);
    const strokePts = (w, col, al) => {
      c.globalAlpha = al * a; c.strokeStyle = col; c.lineWidth = w * wScale;
      c.beginPath(); c.moveTo(pts[0][0], pts[0][1]);
      for (let i = 1; i < pts.length; i++) c.lineTo(pts[i][0], pts[i][1]);
      c.stroke();
    };

    c.shadowBlur = 0;
    c.globalCompositeOperation = "source-over";
    c.lineCap = "round"; c.lineJoin = "round";
    strokePts(11, "rgba(4,2,10,0.92)", 1);
    strokePts(5.5, "rgba(14,8,22,0.96)", 1);
    strokePts(2, "rgba(52,34,78,0.88)", 1);

    // void tear — hard-edged slit (arena void #05060d), scales with charge
    const riftA = (0.06 + 0.72 * chargeVis) * a;
    const riftRad = (2 + 22 * chargeVis) * wScale;
    const t = this.nowS;
    for (let i = 0; i < pts.length; i += 2) {
      const f = pts.length > 1 ? i / (pts.length - 1) : 0;
      const env = Math.sin(f * Math.PI);
      const [x, y] = pts[i];
      const rad = riftRad * (0.75 + 0.25 * env);
      const g = c.createRadialGradient(x, y, 0, x, y, rad);
      g.addColorStop(0, `rgba(5,6,13,${riftA})`);
      g.addColorStop(0.5, `rgba(8,3,18,${riftA * 0.75})`);
      g.addColorStop(1, "rgba(0,0,0,0)");
      c.globalAlpha = 1;
      c.fillStyle = g;
      c.beginPath(); c.arc(x, y, rad, 0, TAU); c.fill();
    }
    if (chargeVis > 0.15) {
      c.globalCompositeOperation = "lighter";
      for (let i = 0; i < pts.length; i += 3) {
        if (Math.sin(b.seed * 3.7 + i * 5.1) < 0.15) continue;
        const f = pts.length > 1 ? i / (pts.length - 1) : 0;
        const env = Math.sin(f * Math.PI);
        const [x, y] = pts[i];
        const rad = riftRad * (0.75 + 0.25 * env);
        const sx = x + Math.sin(b.seed + i * 2.3) * rad * 0.3;
        const sy = y + Math.cos(b.seed + i * 1.7) * rad * 0.3;
        c.globalAlpha = riftA * env;
        c.fillStyle = "#cdd6ff";
        c.beginPath(); c.arc(sx, sy, 0.9, 0, TAU); c.fill();
      }
      c.globalCompositeOperation = "source-over";
    }
    strokePts(0.6 + 1.4 * chargeVis, "rgba(5,6,13,1)", 1);
  }

Game.prototype.drawBeams = function () {
    const c = this.ctx;
    if (!this.beams.length) return;
    c.save();
    c.globalCompositeOperation = "lighter";
    c.lineCap = "round"; c.lineJoin = "round";
    for (const b of this.beams) {
      const a = clamp(1 - b.t / b.life, 0, 1);
      if (b.kind === "void") {
        this.drawVoidBeam(c, b);
        continue;
      }
      const pts = this.beamPoints(b);
      const stroke = (w, col, al) => {
        c.globalAlpha = al * a; c.strokeStyle = col; c.lineWidth = w;
        c.beginPath(); c.moveTo(pts[0][0], pts[0][1]);
        for (let i = 1; i < pts.length; i++) c.lineTo(pts[i][0], pts[i][1]);
        c.stroke();
      };
      const wScale = b.width > 0 ? b.width / 8 : 1;
      stroke(9 * wScale, b.color, 0.25);     // outer glow
      stroke(4 * wScale, b.color, 0.6);      // mid
      stroke(1.6 * wScale, "#ffffff", 0.95); // hot white core
    }
    c.restore();
    c.globalAlpha = 1; c.lineCap = "butt"; c.lineJoin = "miter";
  }

Game.PARTICLE_GLOW_LITE = 120;

Game.prototype.drawParticles = function () {
    const c = this.ctx;
    const lite = this.particles.length > Game.PARTICLE_GLOW_LITE;
    // Draw solid puffs first under normal blending, then additive glows on top
    // so energy/fire reads as light rather than paint. Two passes keep the
    // composite-mode switch to one toggle instead of one per particle.
    for (const pt of this.particles) {
      if (pt.glow) continue;
      const a = clamp(pt.life / pt.maxLife, 0, 1);
      if (pt.kind === "smoke") {
        // soft grey-tinted puff that grows as it fades
        const grow = pt.size * (1 + (1 - a) * 2.2);
        c.globalAlpha = a * 0.5;
        c.fillStyle = pt.color;
        c.beginPath(); c.arc(pt.x, pt.y, grow, 0, TAU); c.fill();
      } else {
        c.globalAlpha = a;
        c.fillStyle = pt.color;
        c.beginPath(); c.arc(pt.x, pt.y, pt.size * (0.4 + 0.6 * a), 0, TAU); c.fill();
      }
    }
    c.globalCompositeOperation = "lighter";
    for (const pt of this.particles) {
      if (!pt.glow) continue;
      const a = clamp(pt.life / pt.maxLife, 0, 1);
      if (pt.kind === "spark") {
        // a streak stretched along its travel direction
        const sp = len(pt.vx, pt.vy);
        const ux = sp > 0.01 ? pt.vx / sp : 1, uy = sp > 0.01 ? pt.vy / sp : 0;
        const tail = clamp(sp * 0.04, pt.size, pt.size * 6);
        c.globalAlpha = a;
        c.strokeStyle = pt.color;
        c.lineWidth = pt.size * (0.5 + 0.5 * a);
        c.lineCap = "round";
        c.beginPath();
        c.moveTo(pt.x, pt.y);
        c.lineTo(pt.x - ux * tail, pt.y - uy * tail);
        c.stroke();
      } else {
        // soft additive blob (a bright core inside a wider halo)
        const r = pt.size * (0.5 + 0.7 * a);
        if (!lite) {
          c.globalAlpha = a * 0.5;
          c.fillStyle = pt.color;
          c.beginPath(); c.arc(pt.x, pt.y, r * 1.8, 0, TAU); c.fill();
        }
        c.globalAlpha = a;
        c.fillStyle = pt.color;
        c.beginPath(); c.arc(pt.x, pt.y, r, 0, TAU); c.fill();
      }
    }
    c.globalCompositeOperation = "source-over";
    c.globalAlpha = 1;
    c.lineCap = "butt";
  }

/** Wooden scarecrow training target (sandbox dummy). */
Game.prototype.drawTrainingDummy = function (c, p) {
  const r = p.radius;
  const woodL = "#c4a066";
  const woodM = "#8b5e2e";
  const woodD = "#4a3218";
  const straw = "#d4bc62";
  const burlap = "#b89870";
  const outline = "rgba(18,10,6,0.88)";
  const footY = r * 0.38;
  const postW = r * 0.22;
  const postTop = footY - r * 4.05;
  const shoulderY = footY - r * 2.55;
  const armHalf = r * 1.35;
  const headY = footY - r * 3.35;
  const headR = r * 0.52;
  const targetY = footY - r * 2.88;
  const wobble = p.knockT > 0 ? Math.sin(this.nowS * 22) * 0.06 * p.knockT : 0;

  this.upright();
  c.save();
  c.rotate(wobble);

  // vertical post
  const pg = c.createLinearGradient(-postW, 0, postW, 0);
  pg.addColorStop(0, woodD);
  pg.addColorStop(0.35, woodM);
  pg.addColorStop(0.65, woodL);
  pg.addColorStop(1, woodD);
  c.fillStyle = pg;
  c.strokeStyle = outline;
  c.lineWidth = 1.5;
  c.beginPath();
  c.roundRect(-postW * 0.5, postTop, postW, footY - postTop + r * 0.08, postW * 0.35);
  c.fill();
  c.stroke();

  // crossbeam arms
  c.fillStyle = woodM;
  c.beginPath();
  c.roundRect(-armHalf, shoulderY - postW * 0.45, armHalf * 2, postW * 0.9, postW * 0.25);
  c.fill();
  c.stroke();

  // straw tufts at shoulders and arm tips
  c.strokeStyle = straw;
  c.lineWidth = 1.8;
  c.lineCap = "round";
  const strawBurst = (sx, sy, dir) => {
    for (let i = 0; i < 5; i++) {
      const a = -0.55 + i * 0.28 + dir * 0.2;
      c.beginPath();
      c.moveTo(sx, sy);
      c.lineTo(sx + Math.cos(a) * r * 0.38, sy + Math.sin(a) * r * 0.22);
      c.stroke();
    }
  };
  strawBurst(-armHalf, shoulderY, -1);
  strawBurst(armHalf, shoulderY, 1);
  strawBurst(-postW * 0.6, shoulderY - r * 0.12, -0.3);
  strawBurst(postW * 0.6, shoulderY - r * 0.12, 0.3);

  // archery target rings on chest
  const rings = [
    { rad: r * 0.62, fill: "#e8e0d0", stroke: outline },
    { rad: r * 0.46, fill: "#d43838", stroke: "rgba(60,8,8,0.7)" },
    { rad: r * 0.30, fill: "#f0ece4", stroke: "rgba(40,30,20,0.55)" },
    { rad: r * 0.14, fill: "#c42828", stroke: "rgba(60,8,8,0.6)" },
  ];
  for (const ring of rings) {
    c.beginPath();
    c.arc(0, targetY, ring.rad, 0, TAU);
    c.fillStyle = ring.fill;
    c.fill();
    c.lineWidth = 1.4;
    c.strokeStyle = ring.stroke;
    c.stroke();
  }

  // burlap head
  const hg = c.createRadialGradient(-headR * 0.25, headY - headR * 0.3, headR * 0.1, 0, headY, headR);
  hg.addColorStop(0, "#d4bc98");
  hg.addColorStop(0.55, burlap);
  hg.addColorStop(1, "#8a7050");
  c.fillStyle = hg;
  c.beginPath();
  c.arc(0, headY, headR, 0, TAU);
  c.fill();
  c.lineWidth = 2;
  c.strokeStyle = outline;
  c.stroke();

  // stitched X eyes + mouth
  c.strokeStyle = "#3a2818";
  c.lineWidth = 2;
  c.lineCap = "round";
  const eyeOff = headR * 0.32;
  for (const ex of [-eyeOff, eyeOff]) {
    c.beginPath();
    c.moveTo(ex - headR * 0.14, headY - headR * 0.12);
    c.lineTo(ex + headR * 0.14, headY + headR * 0.12);
    c.moveTo(ex + headR * 0.14, headY - headR * 0.12);
    c.lineTo(ex - headR * 0.14, headY + headR * 0.12);
    c.stroke();
  }
  c.beginPath();
  c.moveTo(-headR * 0.22, headY + headR * 0.38);
  c.quadraticCurveTo(0, headY + headR * 0.52, headR * 0.22, headY + headR * 0.38);
  c.stroke();

  // floppy hat brim + crown
  c.fillStyle = "#3d2814";
  c.beginPath();
  c.ellipse(0, headY - headR * 0.72, headR * 1.05, headR * 0.28, 0, 0, TAU);
  c.fill();
  c.stroke();
  c.beginPath();
  c.moveTo(-headR * 0.42, headY - headR * 0.72);
  c.quadraticCurveTo(-headR * 0.35, headY - headR * 1.35, 0, headY - headR * 1.42);
  c.quadraticCurveTo(headR * 0.35, headY - headR * 1.35, headR * 0.42, headY - headR * 0.72);
  c.closePath();
  c.fill();
  c.stroke();

  c.restore();
};

/** Aurelion: top-down void-lantern drawn in canvas, rotated to match the live beam angle. */
Game.prototype.drawAurelionRotating = function (c, p, ang) {
  const t = this.nowS;
  const R = p.radius * 3.35;
  c.save();
  c.rotate(ang);

  // void core (single gradient)
  const core = c.createRadialGradient(0, 0, 0, 0, 0, R * 0.62);
  core.addColorStop(0, "#12081c");
  core.addColorStop(0.55, "#3a1860");
  core.addColorStop(1, "#6a38a8");
  c.fillStyle = core;
  c.beginPath(); c.arc(0, 0, R * 0.58, 0, TAU); c.fill();

  // armillary rings (slow counter-spin)
  const ringTilt = [0.55, -0.35, 0.15];
  for (let i = 0; i < 3; i++) {
    c.save();
    c.rotate(ringTilt[i] + t * (0.22 + i * 0.08) * (i % 2 ? 1 : -1));
    c.strokeStyle = i === 0 ? "#e8b840" : "#b88828";
    c.lineWidth = i === 0 ? 3.5 : 2.5;
    c.beginPath();
    c.ellipse(0, 0, R * (0.92 - i * 0.06), R * (0.38 - i * 0.04), 0, 0, TAU);
    c.stroke();
    if (i === 0) {
      c.fillStyle = "#ffd878";
      for (let k = 0; k < 8; k++) {
        const pa = (k / 8) * TAU;
        c.beginPath(); c.arc(Math.cos(pa) * R * 0.92, Math.sin(pa) * R * 0.38, 2.8, 0, TAU); c.fill();
      }
    }
    c.restore();
  }

  // beam emitter eye on +X
  const ex = R * 0.42;
  c.globalCompositeOperation = "lighter";
  const glow = c.createRadialGradient(ex, 0, 0, ex, 0, R * 0.32);
  glow.addColorStop(0, "rgba(255,210,90,0.75)");
  glow.addColorStop(0.45, "rgba(255,150,40,0.25)");
  glow.addColorStop(1, "rgba(255,120,20,0)");
  c.fillStyle = glow;
  c.beginPath(); c.arc(ex, 0, R * 0.32, 0, TAU); c.fill();
  c.globalCompositeOperation = "source-over";

  c.fillStyle = "#c87818";
  c.beginPath(); c.arc(ex, 0, R * 0.14, 0, TAU); c.fill();
  c.fillStyle = "#ff9020";
  c.beginPath(); c.ellipse(ex, 0, R * 0.11, R * 0.075, 0, 0, TAU); c.fill();
  c.fillStyle = "#1a0804";
  c.fillRect(ex - R * 0.018, -R * 0.055, R * 0.036, R * 0.11);

  // orbiting mini-lanterns
  for (let i = 0; i < 4; i++) {
    const la = t * 0.65 + i * (TAU / 4);
    const lx = Math.cos(la) * R * 0.78, ly = Math.sin(la) * R * 0.78;
    c.fillStyle = "#8a6020";
    c.fillRect(lx - 3, ly - 5, 6, 8);
    c.fillStyle = "rgba(255,180,60,0.65)";
    c.fillRect(lx - 2, ly - 3, 4, 4);
  }

  c.restore();
};

/** Ix'tholoth: void eye in a rift — pupil tracks the Hollow Gaze beam angle. */
Game.prototype.drawIxtholothEye = function (c, p, ang) {
  const t = this.nowS;
  const R = p.radius * 3.55;
  const charging = p.channelSpell === "boss_void_bloom" ? (p.channelProg || 0) : 0;
  c.save();
  c.rotate(ang);

  // rift ring
  c.strokeStyle = "#3a1860";
  c.lineWidth = 5;
  c.beginPath(); c.arc(0, 0, R * 0.92, 0, TAU); c.stroke();
  c.strokeStyle = "#6a38a8";
  c.lineWidth = 2.5;
  c.setLineDash([8, 6]);
  c.beginPath(); c.arc(0, 0, R * 0.78, t * 0.4, t * 0.4 + TAU); c.stroke();
  c.setLineDash([]);

  const core = c.createRadialGradient(0, 0, 0, 0, 0, R * 0.72);
  core.addColorStop(0, "#12081c");
  core.addColorStop(0.45, "#3a1860");
  core.addColorStop(0.85, "#6a38a8");
  core.addColorStop(1, "#2a1040");
  c.fillStyle = core;
  c.beginPath(); c.arc(0, 0, R * 0.68, 0, TAU); c.fill();

  // Void Bloom windup — the eye dilates and gathers a violet charge.
  if (charging > 0) {
    c.save();
    c.globalCompositeOperation = "lighter";
    const cr = R * (0.4 + 0.55 * charging) * (1 + 0.04 * Math.sin(t * 18));
    const ch = c.createRadialGradient(0, 0, 0, 0, 0, cr);
    ch.addColorStop(0, `rgba(180,90,240,${0.18 + 0.4 * charging})`);
    ch.addColorStop(0.6, `rgba(120,50,200,${0.12 + 0.2 * charging})`);
    ch.addColorStop(1, "rgba(60,20,110,0)");
    c.fillStyle = ch;
    c.beginPath(); c.arc(0, 0, cr, 0, TAU); c.fill();
    c.restore();
  }

  // tracking pupil on +X
  const ex = R * 0.18;
  c.globalCompositeOperation = "lighter";
  const glow = c.createRadialGradient(ex, 0, 0, ex, 0, R * 0.28);
  glow.addColorStop(0, "rgba(180,80,255,0.55)");
  glow.addColorStop(0.5, "rgba(106,56,168,0.22)");
  glow.addColorStop(1, "rgba(58,24,96,0)");
  c.fillStyle = glow;
  c.beginPath(); c.arc(ex, 0, R * 0.28, 0, TAU); c.fill();
  c.globalCompositeOperation = "source-over";

  c.fillStyle = "#1a0818";
  c.beginPath(); c.ellipse(ex, 0, R * 0.09, R * 0.14, 0, 0, TAU); c.fill();
  c.fillStyle = "#4a8a40";
  c.fillRect(ex - R * 0.012, -R * 0.07, R * 0.024, R * 0.14);

  c.restore();
};

Game.prototype.drawPlayers = function () {
    const me = this.human();
    for (const p of this.players) this.drawPlayer(p, me);
    this.ctx.globalAlpha = 1;
  }

// One wizard (ground shadow + billboarded body + auras + status), translated to
// its world anchor. Split out of drawPlayers so it can be depth-interleaved with
// the pillars — a wizard standing behind a tall stone is then occluded by it.
Game.prototype.drawPlayer = function (p, me) {
    const c = this.ctx;
    if (!p.alive) return;
    const scale = p.falling ? clamp(1 - p.fallT, 0, 1) : 1;
    let alpha = p.falling ? clamp(1 - p.fallT * 0.9, 0, 1) : 1;
    // Wind Walk: invisible to everyone else — only you can see yourself (faded).
    if (p.invisT > 0) {
      if (p !== me) return;
      alpha *= 0.5;
    }
    if (scale <= 0.02) return;

    c.save();
    c.translate(p.x, p.y);
    c.globalAlpha = alpha;

      // shadow on platform (bosses get a large feet-anchored shadow)
      drawEntityGroundShadow(c, p);

      // training dummy: scarecrow target (no wizard sprite)
      if (p.dummy) {
        this.drawTrainingDummy(c, p);
        c.restore();
        if (!p.falling) this.drawHPBarWorld(p.x, p.y, p.radius, p.hp, p.outside);
        return;
      }

      // ally ring: a green ground ring under your teammates (grouped only)
      {
        const me = this.human();
        if (!p.falling && me && p !== me && p.team != null && p.team === me.team) {
          c.strokeStyle = "rgba(116,247,160,0.7)"; c.lineWidth = 2.5;
          c.beginPath(); c.ellipse(0, p.radius * 0.7, p.radius * 1.05, p.radius * 0.5, 0, 0, TAU); c.stroke();
        }
      }

      const mirrorCourtActive = (p.boss === "kael" || p.mirrorAdd) &&
        this.players.some(m => m.mirrorAdd && m.alive);
      const mirrorCourtShield = mirrorCourtActive && p.boss === "kael" && !p.mirrorAdd;

      // Boss AoE windups — ground plane (before upright); circles foreshorten with the tilted arena.
      if (p.boss && !p.falling) {
        const lethal = this.lethalChannelProgress(p);
        if (lethal?.active) {
          if (lethal.kind === "plague") {
            this.drawBossJudgmentChannel(c, p, clamp(lethal.prog, 0, 1), "#a8c860", "#6a8a30");
          } else {
            this.drawBossJudgmentChannel(c, p, clamp(lethal.prog, 0, 1));
          }
        }
        if (p.channelSpell === "boss_shatter") {
          this.drawBossShatterChannel(c, p, clamp(Math.max(p.channelProg, 0.04), 0, 1));
        }
        if (p.channelSpell === "boss_radiant_sweep" && p.channelProg > 0) {
          this.drawBossJudgmentChannel(c, p, clamp(p.channelProg, 0, 1), "#ffd878", "#e8b840");
        }
      }

      if (mirrorCourtShield) this.drawMirrorCourtImmunityWard(c, p, "ground");

      // Billboard: undo the ground Y-foreshorten so the wizard (and its auras) stand
      // upright at full height instead of being squashed by the oblique camera. Ground
      // elements (shadow, ally ring) above stay squashed.
      this.upright();
      c.scale(scale, scale);

      // shield bubble — a glassy hex-fresnel dome with a rotating sheen
      if (p.shieldT > 0) {
        const tt = this.nowS;
        const br = p.radius + 12;
        c.save();
        c.fillStyle = this.grad("shield:" + br, c2 => {
          const bg = c2.createRadialGradient(0, 0, br * 0.4, 0, 0, br);
          bg.addColorStop(0, "rgba(125,180,255,0.04)");
          bg.addColorStop(0.8, "rgba(125,180,255,0.10)");
          bg.addColorStop(1, "rgba(160,210,255,0.28)");
          return bg;
        });
        c.beginPath(); c.arc(0, 0, br, 0, TAU); c.fill();
        c.lineWidth = 2.5;
        c.strokeStyle = `rgba(150,200,255,${0.5 + 0.25 * Math.sin(tt * 9)})`;
        c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
        // faint hex facets
        c.globalCompositeOperation = "lighter";
        c.strokeStyle = "rgba(150,200,255,0.18)"; c.lineWidth = 1;
        c.beginPath();
        for (let i = 0; i < 6; i++) { const a = i / 6 * TAU + tt * 0.6; c.moveTo(0, 0); c.lineTo(Math.cos(a) * br, Math.sin(a) * br); }
        c.stroke();
        // travelling specular arc
        const sa = tt * 2 % TAU;
        c.strokeStyle = "rgba(220,240,255,0.7)"; c.lineWidth = 3;
        c.beginPath(); c.arc(0, 0, br - 1, sa, sa + 0.9); c.stroke();
        c.restore();
      }
      if (mirrorCourtShield) this.drawMirrorCourtImmunityWard(c, p, "body");
      // Arcane Barrier ward — a violet rune-bubble that soaks HP (distinct from
      // the blue knockback Shield): twin counter-rotating glyph rings + soft fill.
      if (p.absorbT > 0) {
        const tt = this.nowS;
        const br = p.radius + 15;
        c.save();
        c.fillStyle = this.grad("absorb:" + br, c2 => {
          const bg = c2.createRadialGradient(0, 0, br * 0.3, 0, 0, br);
          bg.addColorStop(0, "rgba(201,160,255,0.03)");
          bg.addColorStop(0.75, "rgba(201,160,255,0.10)");
          bg.addColorStop(1, "rgba(176,130,255,0.30)");
          return bg;
        });
        c.beginPath(); c.arc(0, 0, br, 0, TAU); c.fill();
        c.globalCompositeOperation = "lighter";
        c.lineWidth = 2;
        c.strokeStyle = `rgba(201,160,255,${0.5 + 0.25 * Math.sin(tt * 6)})`;
        c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
        // rune tick marks on two counter-rotating rings
        for (let ring = 0; ring < 2; ring++) {
          const dir = ring ? -1 : 1, rr = br - 2 - ring * 4;
          c.strokeStyle = `rgba(220,200,255,${ring ? 0.4 : 0.6})`;
          c.lineWidth = ring ? 1.5 : 2;
          for (let i = 0; i < 8; i++) {
            const a = i / 8 * TAU + dir * tt * (ring ? 0.7 : 1.1);
            c.beginPath();
            c.moveTo(Math.cos(a) * (rr - 4), Math.sin(a) * (rr - 4));
            c.lineTo(Math.cos(a) * rr, Math.sin(a) * rr);
            c.stroke();
          }
        }
        c.restore();
      }
      // Reflect Shield — a mirror dome: silvery-cyan bubble with a sweeping
      // specular glint and crisp rim, distinct from the blue knockback Shield.
      if (p.reflectT > 0) {
        const tt = this.nowS;
        const br = p.radius + 13;
        c.save();
        c.fillStyle = this.grad("reflect:" + br, c2 => {
          const bg = c2.createRadialGradient(-br * 0.3, -br * 0.3, br * 0.2, 0, 0, br);
          bg.addColorStop(0, "rgba(235,250,255,0.16)");
          bg.addColorStop(0.7, "rgba(159,231,255,0.10)");
          bg.addColorStop(1, "rgba(190,235,255,0.34)");
          return bg;
        });
        c.beginPath(); c.arc(0, 0, br, 0, TAU); c.fill();
        c.globalCompositeOperation = "lighter";
        c.lineWidth = 2.5;
        c.strokeStyle = `rgba(200,240,255,${0.55 + 0.25 * Math.sin(tt * 7)})`;
        c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
        // two bright specular glints sweeping opposite ways (mirror sheen)
        for (let i = 0; i < 2; i++) {
          const ga = (tt * (i ? -1.6 : 2.2) + i * Math.PI) % TAU;
          c.strokeStyle = "rgba(255,255,255,0.85)"; c.lineWidth = 3;
          c.beginPath(); c.arc(0, 0, br - 1, ga, ga + 0.55); c.stroke();
        }
        c.restore();
      }
      // Rush aura — green energy ring + speed streaks behind the heading
      if (p.rushT > 0) {
        const tt = this.nowS;
        c.save();
        c.globalCompositeOperation = "lighter";
        c.strokeStyle = `rgba(154,255,176,${0.45 + 0.2 * Math.sin(tt * 9)})`;
        c.lineWidth = 2.5;
        c.beginPath(); c.arc(0, 0, p.radius + 8, 0, TAU); c.stroke();
        c.restore();
      }
      // Colossus Charge — stone ram-shield ahead of the heading
      if (p.dashSpell === "boss_colossus_charge" || p.dashSpell === "boss_blink_strike" || p.dashSpell === "boss_trample") {
        const tint = p.dashSpell === "boss_blink_strike" ? "#a060e0" : (p.dashSpell === "boss_trample" ? "#6a8a30" : undefined);
        this.drawColossusChargeFront(c, p, tint);
      }
      // Kael blink vulnerability — cracked arcane ward ring + burst cue
      if (p.boss === "kael" && p.blinkVuln) {
        const tt = this.nowS;
        const br = p.radius + 14;
        c.save();
        c.globalCompositeOperation = "lighter";
        c.strokeStyle = `rgba(220,160,255,${0.7 + 0.25 * Math.sin(tt * 12)})`;
        c.lineWidth = 3.5;
        c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
        c.strokeStyle = `rgba(255,220,255,${0.45 + 0.25 * Math.sin(tt * 15 + 0.5)})`;
        c.lineWidth = 2;
        c.setLineDash([6, 5]);
        c.beginPath(); c.arc(0, 0, br + 7, tt * 2.2, tt * 2.2 + Math.PI * 1.35); c.stroke();
        c.setLineDash([]);
        c.fillStyle = `rgba(180,100,255,${0.12 + 0.08 * Math.sin(tt * 9)})`;
        c.beginPath(); c.arc(0, 0, br + 3, 0, TAU); c.fill();
        c.restore();
      }
      // Enraged boss — pulsing ember ring + rising sparks (Titan below 30% HP)
      if (p.boss && p.enraged) {
        const tt = this.nowS;
        const br = p.radius + 14;
        const isPlague = p.boss === "groshkar";
        const isFrost = p.boss === "vorathal";
        c.save();
        c.globalCompositeOperation = "lighter";
        if (isPlague) {
          c.strokeStyle = `rgba(200,208,64,${0.5 + 0.25 * Math.sin(tt * 8)})`;
          c.lineWidth = 3.5;
          c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
          c.strokeStyle = `rgba(106,138,48,${0.35 + 0.2 * Math.sin(tt * 11 + 1)})`;
        } else if (isFrost) {
          c.strokeStyle = `rgba(168,212,240,${0.5 + 0.25 * Math.sin(tt * 8)})`;
          c.lineWidth = 3.5;
          c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
          c.strokeStyle = `rgba(232,244,255,${0.35 + 0.2 * Math.sin(tt * 11 + 1)})`;
        } else {
          c.strokeStyle = `rgba(255,96,48,${0.5 + 0.25 * Math.sin(tt * 8)})`;
          c.lineWidth = 3.5;
          c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
          c.strokeStyle = `rgba(255,180,80,${0.35 + 0.2 * Math.sin(tt * 11 + 1)})`;
        }
        c.lineWidth = 2;
        c.beginPath(); c.arc(0, 0, br + 6, 0, TAU); c.stroke();
        c.restore();
        if (Math.random() < 0.12) {
          this.particles.push(new Particle(
            p.x + rand(-p.radius, p.radius), p.y - p.radius * 0.3,
            rand(-18, 18), rand(-55, -20),
            isPlague ? "#c8d040" : isFrost ? "#a8d4f0" : "#ff8040", rand(2, 4), 0.35, { kind: "glow" }
          ));
        }
      }
      this.drawContagionOverlay(c, p);
      if (p.isHuman || (this.inSpectateView() && p.id === this.spectateWatchId)) {
        this.drawOnIceSparkles(c, p);
        this.drawShatterVulnerabilityOverlay(c, p);
      }
      if (p.mindLashT > 0 && p.moveTarget) {
        // Arrow pointing where the hero will ACTUALLY go (opposite the cursor),
        // so the reversed-controls debuff is legible instead of disorienting.
        const idx = p.x - p.moveTarget.x, idy = p.y - p.moveTarget.y;
        const il = Math.hypot(idx, idy) || 1;
        c.save();
        c.globalCompositeOperation = "lighter";
        c.strokeStyle = "rgba(160,80,235,0.6)";
        c.lineWidth = 2.5;
        c.setLineDash([5, 5]);
        c.beginPath();
        c.moveTo(0, 0);
        c.lineTo((idx / il) * 80, (idy / il) * 80);
        c.stroke();
        c.restore();
      }
      if (p.mindCtrlT > 0) {
        c.save();
        c.fillStyle = "rgba(80,20,140,0.22)";
        c.beginPath(); c.arc(0, 0, p.radius + 16, 0, TAU); c.fill();
        c.restore();
      }

      if (p.boss && !p.mirrorAdd) this.drawBossAmbient(c, p, "back");

      if (p.falling) c.rotate(p.fallT * 8); // tumble only while falling into the void
      if (p.boss === "aurelion") {
        const spin = p.beamSpin ?? this.bossBeamSpinAngle(p) ?? p.facing ?? Math.PI / 2;
        this.drawAurelionRotating(c, p, spin);
      } else if (p.boss === "ixtholoth") {
        const spin = p.beamSpin ?? this.bossBeamSpinAngle(p) ?? p.facing ?? Math.PI / 2;
        this.drawIxtholothEye(c, p, spin);
      } else {
      // 8-direction art if loaded; else the procedural sprite (mirrored
      // left/right toward the heading) as a fallback while images load.
      const oct = p.spriteOct != null ? p.spriteOct : octIndex(p.facing);
      const chProg = p.channelSpell ? (p.channelProg || 0) : 0;
      const castProg = Math.max(chProg, p.castPose || 0);
      let img = null;
      if (p.addKind) {
        img = addKindImageByOct(p.addKind, oct);
      }
      if (!img && !p.addKind) {
        img = (p.boss ? bossImageByOct(p.boss, oct) : null) || warlockImageByOct(p.index, oct);
      }
      if (p.boss && castProg > 0) {
        const phase = castProg < 0.6 ? "mid" : "end";
        const castImg = bossCastImageByOct(p.boss, oct, phase);
        if (castImg) img = castImg;
      } else if (!p.boss && !p.addKind && castProg > 0) {
        const phase = castProg < 0.6 ? "mid" : "end";
        const castImg = warlockCastImageByOct(p.index, oct, phase);
        if (castImg) img = castImg;
      }
      if (img) {
        // procedural idle/walk animation (no frame sheets in the art): a bounce
        // that's bigger & faster while moving, plus a subtle vertical squash.
        const moving = this.playerWalkBob(p);
        const ph = this.nowS * (moving ? 11 : 2.6) + p.index * 1.7;
        const bobAmt = p.boss ? (moving ? 0.10 : 0.03) : p.addKind ? (moving ? 0.18 : 0.06) : (moving ? 0.22 : 0.07);
        const bob = p.falling ? 0 : -Math.abs(Math.sin(ph)) * p.radius * bobAmt;
        const squash = 1 + Math.sin(ph * 2) * (moving ? 0.05 : 0.02);
        const baseH = p.boss === "kael" ? p.radius * 9.5 : p.boss ? p.radius * 10.5 : p.addKind ? p.radius * 6.5 : p.radius * 7.6;
        const aspect = img.naturalWidth / img.naturalHeight;
        const gorgeTint = p.boss === "groshkar" && p.gorgeStacks > 0;
        const gorgeScale = gorgeTint ? 1 + p.gorgeStacks * 0.015 : 1;
        const dh = baseH * squash * gorgeScale, dw = baseH * aspect * gorgeScale;
        const mirrorAlpha = mirrorCourtActive ? (0.92 + 0.06 * Math.sin(this.nowS * 14 + p.id)) : 1;
        if (mirrorAlpha < 1) c.globalAlpha = mirrorAlpha;
        if (gorgeTint) {
          c.save();
          c.filter = `saturate(${1 + p.gorgeStacks * 0.08}) brightness(${1 + p.gorgeStacks * 0.04})`;
        }
        c.drawImage(img, -dw / 2, -dh / 2 - p.radius * 0.5 + bob, dw, dh);
        if (gorgeTint) c.restore();
        if (mirrorAlpha < 1) c.globalAlpha = 1;
      } else {
        const cx = Math.cos(p.facing);
        if (p.faceDir === undefined) p.faceDir = 1;
        if (Math.abs(cx) > 0.2) p.faceDir = cx < 0 ? -1 : 1;
        const spr = this.sprite(p);
        const ss = (p.radius / SPRITE_BRIM) * 1.15;
        c.scale(ss * p.faceDir, ss);
        c.drawImage(spr, -spr.width / 2, -spr.height / 2);
      }
      }

      if (mirrorCourtShield) this.drawMirrorCourtImmunityWard(c, p, "front");

      if (p.boss && !p.mirrorAdd && !p.falling) this.drawBossAmbient(c, p, "front");

      if (p.boss && p.castLabel) {
        this.drawBossCastLabel(c, p);
      }

      c.restore();

      // ---- status overlays (world space, on top of the sprite) ----
      if (!p.falling) this.drawStatus(p);

      // health bar (shown when damaged or burning over the void)
      if (!p.falling && p.boss !== "morwenna" && p.boss !== "lys") {
        const hpBarMax = (p.boss || p.bossAdd) ? (p.maxHP || p.effMaxHP()) : 0;
        this.drawHPBarWorld(p.x, p.y, p.radius, p.hp, p.outside, hpBarMax, p.boss, p.bossAdd);
      }

      if (!p.falling && (p.essenceMark || p.attuneProg > 0)) {
        const toward = p.attuneToward || p.essenceMark;
        const light = toward === 1;
        const markCol = light ? "#e8b840" : "#8040a0";
        const markSoft = light ? "#ffe8a0" : "#c080e0";
        c.save();
        c.globalCompositeOperation = "lighter";
        if (p.essenceMark) {
          const footR = p.radius + 14;
          const aura = c.createRadialGradient(0, p.radius * 0.35, 0, 0, p.radius * 0.35, footR);
          aura.addColorStop(0, light ? "rgba(255, 220, 120, 0.28)" : "rgba(180, 100, 255, 0.26)");
          aura.addColorStop(0.55, light ? "rgba(255, 196, 64, 0.12)" : "rgba(128, 64, 200, 0.11)");
          aura.addColorStop(1, "rgba(0,0,0,0)");
          c.fillStyle = aura;
          c.beginPath();
          c.arc(0, p.radius * 0.35, footR, 0, TAU);
          c.fill();
          c.strokeStyle = markCol;
          c.lineWidth = 2.5;
          c.beginPath();
          c.arc(0, -p.radius * 5.2, p.radius + 6, 0, TAU);
          c.stroke();
          const tagPx = Math.round(Math.max(10, 12 / this.scale));
          const tagY = -p.radius * 5.2;
          c.font = `700 ${tagPx}px sans-serif`;
          c.textAlign = "center";
          c.textBaseline = "middle";
          c.strokeStyle = "rgba(0,0,0,0.75)";
          c.lineWidth = 3;
          c.strokeText(light ? "LIGHT" : "VOID", 0, tagY);
          c.fillStyle = markSoft;
          c.fillText(light ? "LIGHT" : "VOID", 0, tagY);
        }
        if (p.attuneProg > 0) {
          c.strokeStyle = p.essenceMark ? "rgba(255,255,255,0.85)" : markCol;
          c.lineWidth = 2.5;
          c.beginPath();
          c.arc(0, -p.radius * 5.2, p.radius + (p.essenceMark ? 10 : 8), -Math.PI / 2, -Math.PI / 2 + TAU * p.attuneProg);
          c.stroke();
        }
        c.restore();
      }

      // aim line for local player or spectated perspective
      const showAim = !p.falling && (p.isHuman || (this.inSpectateView() && p.id === this.spectateWatchId));
      if (showAim) {
        c.save();
        c.globalAlpha = 0.25;
        c.strokeStyle = "#ffffff"; c.lineWidth = 1.5;
        c.setLineDash([4, 8]);
        c.beginPath(); c.moveTo(p.x, p.y);
        c.lineTo(p.x + Math.cos(p.aim) * 90, p.y + Math.sin(p.aim) * 90); c.stroke();
        c.restore();
        // move-target marker (local player only). Under Mind Lash the hero moves
        // to the point-reflection of the cursor, so show the marker there.
        if (p.isHuman && p.moveTarget) {
          c.save();
          const lashed = p.mindLashT > 0;
          const mt = p.moveTarget, ps = 1 + 0.2 * Math.sin(this.now / 120);
          const tx = lashed ? 2 * p.x - mt.x : mt.x;
          const ty = lashed ? 2 * p.y - mt.y : mt.y;
          c.globalAlpha = 0.5; c.strokeStyle = lashed ? "#b060e6" : p.trim; c.lineWidth = 2;
          c.beginPath(); c.arc(tx, ty, 7 * ps, 0, TAU); c.stroke();
          c.restore();
        }
      }
  }

Game.prototype.drawDecoys = function () {
    const c = this.ctx;
    for (const d of this.decoys) {
      const arming = d.detonateT > 0;
      const scale = d.scale ?? 1;
      const r = d.radius;
      const drawX = d.x;
      const drawY = d.y;
      if (arming) {
        const charge = 1 - d.detonateT / 1;
        c.save();
        c.translate(drawX, drawY);
        c.strokeStyle = `rgba(255, 90, 40, ${0.25 + charge * 0.5})`;
        c.lineWidth = 2 + charge * 3;
        c.beginPath();
        c.arc(0, 0, r * (1.05 + charge * 0.15), 0, TAU);
        c.stroke();
        c.restore();
      }
      c.save();
      c.translate(drawX, drawY);
      c.fillStyle = "rgba(0,0,0,0.35)";
      c.beginPath(); c.ellipse(0, r * 0.7, r * 0.9, r * 0.4, 0, 0, TAU); c.fill();
      // billboard the decoy art upright (ground shadow above stays squashed)
      this.upright();
      const img = warlockImage(d.index, d.facing);
      if (img) {
        const sp = len(d.x - (d._bx ?? d.x), d.y - (d._by ?? d.y)); d._bx = d.x; d._by = d.y;
        const moving = !arming && sp > 0.35;
        const ph = this.nowS * (moving ? 11 : 2.6) + d.index * 1.7;
        const bob = -Math.abs(Math.sin(ph)) * r * (moving ? 0.22 : 0.07);
        const squash = 1 + Math.sin(ph * 2) * (moving ? 0.05 : 0.02);
        const baseH = r * 7.6, aspect = img.naturalWidth / img.naturalHeight;
        const dh = baseH * squash, dw = baseH * aspect;
        c.drawImage(img, -dw / 2, -dh / 2 - r * 0.5 + bob, dw, dh);
      } else {
        const cx = Math.cos(d.facing);
        const faceDir = Math.abs(cx) > 0.2 ? (cx < 0 ? -1 : 1) : 1;
        const spr = this.sprite(d);
        const ss = (r / SPRITE_BRIM) * 1.15;
        c.scale(ss * faceDir, ss);
        c.drawImage(spr, -spr.width / 2, -spr.height / 2);
      }
      c.restore();
      const owner = this.playerById[d.ownerId];
      const me = this.human();
      if (owner && owner.alive && !owner.falling && !(owner.invisT > 0 && owner !== me) && !arming && scale >= 0.85) {
        const outside = Math.hypot(d.x, d.y) > this.platformRadius;
        this.drawHPBarWorld(d.x, d.y, r, d.hp, outside);
      }
      if (d.ownerId === this.myId) {
        const pulse = arming
          ? 0.65 + 0.25 * Math.sin(this.nowS * 10)
          : 0.55 + 0.25 * Math.sin(this.nowS * 5 + d.id);
        c.save();
        c.translate(d.x, d.y);
        c.strokeStyle = arming
          ? `rgba(255, 110, 50, ${pulse})`
          : d.suicide
            ? `rgba(255, 130, 70, ${0.45 + 0.2 * Math.sin(this.nowS * 6 + d.id)})`
            : `rgba(170, 110, 255, ${pulse})`;
        c.lineWidth = arming ? 3 : 2.5;
        c.setLineDash(arming ? [5, 4] : [7, 5]);
        c.beginPath();
        c.ellipse(0, r * 0.35, r * 1.1, r * 1.25, 0, 0, TAU);
        c.stroke();
        c.setLineDash([]);
        c.restore();
      }
    }
  }

Game.prototype.drawFlameShackle = function (p) {
    const c = this.ctx;
    const t = this.nowS;
    const r = p.radius;
    c.save();
    c.translate(p.x, p.y);
    // four jagged flame spires around the target
    const pr = r * 1.35;
    for (let i = 0; i < 4; i++) {
      const a = i / 4 * TAU + Math.PI / 4;
      const px = Math.cos(a) * pr, py = Math.sin(a) * pr * 0.55 + r * 0.15;
      c.save();
      c.translate(px, py);
      c.rotate(a + Math.PI / 2);
      c.fillStyle = "rgba(255,120,40,0.88)";
      c.strokeStyle = "rgba(255,200,80,0.92)";
      c.lineWidth = 1.5;
      c.beginPath();
      c.moveTo(-5, 8); c.lineTo(-3, -14); c.lineTo(0, -18); c.lineTo(3, -14); c.lineTo(5, 8);
      c.closePath(); c.fill(); c.stroke();
      c.restore();
    }
    // ember bands wrapping the torso
    c.strokeStyle = "rgba(255,140,50,0.92)"; c.lineWidth = 2.5; c.lineCap = "round";
    for (let band = 0; band < 3; band++) {
      const ry = -r * 0.15 + band * r * 0.28;
      const rx = r * (0.75 - band * 0.08);
      c.beginPath();
      c.ellipse(0, ry, rx, r * 0.22, 0, 0, TAU);
      c.stroke();
    }
    c.lineWidth = 2;
    for (let i = 0; i < 4; i++) {
      const a = i / 4 * TAU + t * 0.6;
      c.beginPath();
      c.moveTo(Math.cos(a) * pr * 0.85, Math.sin(a) * pr * 0.35);
      c.quadraticCurveTo(0, -r * 0.2, Math.cos(a + Math.PI) * r * 0.55, Math.sin(a + Math.PI) * r * 0.15);
      c.stroke();
    }
    // flickering flame crown above the head
    c.save(); c.globalCompositeOperation = "lighter";
    c.strokeStyle = `rgba(255,120,40,${0.5 + 0.25 * Math.sin(t * 5)})`;
    c.lineWidth = 2;
    c.beginPath();
    c.ellipse(0, -r * 1.05, r * 0.55, r * 0.12, t * 2, 0, TAU);
    c.stroke();
    c.restore();
    c.restore();
    if (this.state === "playing" && Math.random() < 0.28)
      this.particles.push(new Particle(p.x + rand(-r, r), p.y - r * 0.8, rand(-6, 6), rand(-8, 4),
        rand(0.35, 0.65), Math.random() < 0.5 ? "#ff8844" : "#ffd479", rand(1.5, 2.5), { kind: "glow" }));
  }

Game.prototype.drawStatus = function (p) {
    const c = this.ctx;
    const t = this.nowS;
    const r = p.radius;

    // Frozen (root + silence) = encased in an ice block; Rooted only = vines.
    if (p.root > 0 && p.silence > 0) {
      c.save();
      c.translate(p.x, p.y);
      // frosty glow halo
      c.save(); c.globalCompositeOperation = "lighter";
      c.fillStyle = "rgba(150,225,255,0.18)";
      c.beginPath(); c.arc(0, 0, r + 14, 0, TAU); c.fill();
      c.restore();
      // jagged ice block around the wizard
      c.fillStyle = "rgba(170,230,255,0.30)";
      c.strokeStyle = "rgba(220,248,255,0.9)";
      c.lineWidth = 2;
      c.beginPath();
      const spikes = 9;
      for (let i = 0; i <= spikes; i++) {
        const a = i / spikes * TAU - Math.PI / 2;
        const rr = r + 6 + ((i % 2) ? 8 : 0);
        const x = Math.cos(a) * rr, y = Math.sin(a) * (rr * 1.05);
        i ? c.lineTo(x, y) : c.moveTo(x, y);
      }
      c.closePath(); c.fill(); c.stroke();
      // inner facet sheen
      c.strokeStyle = "rgba(255,255,255,0.55)"; c.lineWidth = 1;
      c.beginPath(); c.moveTo(-r * 0.4, -r * 0.8); c.lineTo(r * 0.2, r * 0.6); c.moveTo(r * 0.5, -r * 0.5); c.lineTo(-r * 0.1, r * 0.4); c.stroke();
      c.restore();
      // occasional frost mote drifting off
      if (this.state === "playing" && Math.random() < 0.2)
        this.particles.push(new Particle(p.x + rand(-r, r), p.y + rand(-r, r), rand(-8, 8), rand(-4, 12),
          rand(0.4, 0.8), "#cdf3ff", rand(1.5, 3), { kind: "glow" }));
    } else if (p.freeze > 0) {
      // Frost Nova freeze: icy ring and crystals at the feet (can still cast, not silenced)
      c.save();
      c.translate(p.x, p.y + r * 0.72);
      c.fillStyle = "rgba(150,225,255,0.22)";
      c.strokeStyle = "rgba(200,245,255,0.85)"; c.lineWidth = 2.5;
      c.beginPath(); c.ellipse(0, 0, r * 1.05, r * 0.42, 0, 0, TAU); c.fill(); c.stroke();
      c.lineWidth = 2; c.strokeStyle = "rgba(255,255,255,0.75)";
      for (let i = 0; i < 6; i++) {
        const a = i / 6 * TAU + t * 0.8;
        const sx = Math.cos(a) * r * 0.75, sy = Math.sin(a) * r * 0.22 - 4;
        c.beginPath();
        c.moveTo(sx, sy + 6); c.lineTo(sx - 3, sy); c.lineTo(sx + 3, sy); c.closePath(); c.stroke();
      }
      c.restore();
      if (this.state === "playing" && Math.random() < 0.18)
        this.particles.push(new Particle(p.x + rand(-r * 0.6, r * 0.6), p.y + r * 0.55, rand(-5, 5), rand(-2, 8),
          rand(0.35, 0.65), "#cdf3ff", rand(1.5, 2.5), { kind: "glow" }));
    } else if (p.root > 0 && p.rootSpell === "boss_radiant_burst") {
      this.drawFlameShackle(p);
    } else if (p.root > 0) {
      // earthy vines clamping the feet
      c.save();
      c.translate(p.x, p.y + r * 0.7);
      c.strokeStyle = "rgba(150,110,80,0.9)"; c.lineWidth = 3; c.lineCap = "round";
      c.beginPath(); c.ellipse(0, 0, r * 0.95, r * 0.45, 0, 0, TAU); c.stroke();
      c.lineWidth = 2.5; c.strokeStyle = "rgba(120,160,90,0.9)";
      for (let i = 0; i < 5; i++) {
        const a = i / 5 * TAU + t;
        c.beginPath(); c.moveTo(Math.cos(a) * r * 0.7, Math.sin(a) * r * 0.3);
        c.quadraticCurveTo(Math.cos(a) * r * 1.1, -r * 0.6, Math.cos(a) * r * 0.6, -r * 1.0); c.stroke();
      }
      c.lineCap = "butt";
      c.restore();
    }

    // Slow = heavy chilled aura with sluggish swirl + sinking blue motes
    if (p.slowT > 0 && !(p.root > 0)) {
      c.save();
      c.globalCompositeOperation = "lighter";
      c.strokeStyle = "rgba(120,170,255,0.55)"; c.lineWidth = 2.5;
      const a0 = t * 1.2 % TAU;
      c.beginPath(); c.arc(p.x, p.y, r + 6, a0, a0 + Math.PI * 1.3); c.stroke();
      c.strokeStyle = "rgba(120,170,255,0.3)"; c.lineWidth = 2;
      c.beginPath(); c.arc(p.x, p.y, r + 11, -a0, -a0 + Math.PI); c.stroke();
      c.restore();
      if (this.state === "playing" && Math.random() < 0.25)
        this.particles.push(new Particle(p.x + rand(-r, r), p.y - r * 0.5, rand(-6, 6), rand(10, 30),
          rand(0.4, 0.7), "#9ec8ff", rand(1.5, 3), { kind: "glow", grav: 30 }));
    }

    // Burning = licking flames + rising embers and smoke
    if (p.burnT > 0) {
      c.save();
      c.globalCompositeOperation = "lighter";
      for (let i = 0; i < 4; i++) {
        const ph = t * 7 + i * 1.7;
        const fx = p.x + Math.sin(ph) * r * 0.55 + (i - 1.5) * 5;
        const fy = p.y - r * 0.5 - (Math.sin(ph * 1.3) * 0.5 + 0.5) * 14;
        const sz = 3 + 2.5 * (Math.sin(ph) * 0.5 + 0.5);
        c.fillStyle = i % 2 ? "rgba(255,210,110,0.9)" : "rgba(255,100,35,0.85)";
        c.beginPath(); c.arc(fx, fy, sz, 0, TAU); c.fill();
      }
      c.restore();
      if (this.state === "playing" && Math.random() < 0.5)
        this.particles.push(new Particle(p.x + rand(-r * 0.7, r * 0.7), p.y - r * 0.3, rand(-12, 12), rand(-50, -20),
          rand(0.3, 0.6), Math.random() < 0.6 ? "#ff7a2f" : "#ffd479", rand(2, 4), { kind: "glow", grav: -80 }));
      if (this.state === "playing" && Math.random() < 0.15)
        this.particles.push(new Particle(p.x + rand(-r * 0.5, r * 0.5), p.y - r, rand(-6, 6), rand(-30, -10),
          rand(0.5, 0.9), "#2a201c", rand(3, 5), { kind: "smoke", grav: -50 }));
    }

    // Hemorrhage = bleeding arm; drips and squirts stain the arena floor
    if (p.hemorrhageT > 0) {
      const boneChannel = p.channelProg > 0 && p.channelSpell === "bonespear";
      const scale = boneChannel ? 1.6 + p.channelProg * 0.9 : 1;
      const dripCount = boneChannel ? 6 : 3;
      c.save();
      for (let i = 0; i < dripCount; i++) {
        const ph = t * (boneChannel ? 7 : 5) + i * 2.1 + p.index;
        const dripX = p.x + Math.sin(ph) * r * 0.35 + (i - dripCount / 2) * 4;
        const dripY = p.y - r * 0.15 + (Math.sin(ph * 1.4) * 0.5 + 0.5) * r * 0.55;
        c.fillStyle = "rgba(160,18,28,0.85)";
        c.beginPath();
        c.ellipse(dripX, dripY, 2.2 * scale, (4.5 + Math.sin(ph * 2) * 1.2) * scale, 0, 0, TAU);
        c.fill();
      }
      c.restore();
      if (this.state === "playing") {
        const dripChance = boneChannel ? 0.72 : 0.42;
        const squirtChance = boneChannel ? 0.42 : 0.1;
        if (Math.random() < dripChance) {
          const footX = p.x + rand(-r * 0.45, r * 0.45);
          const footY = p.y + r * 0.52 + rand(0, r * 0.18);
          this.spawnBloodStain(footX, footY, rand(3.5, 7.5) * scale);
          this.particles.push(new Particle(footX, footY - 2, rand(-4, 4), rand(18, 48) * scale,
            rand(0.28, 0.5), "#8a1020", rand(1.5, 3) * scale, { kind: "dot", grav: 120 }));
        }
        if (Math.random() < squirtChance) {
          const aim = boneChannel && p.aim != null ? p.aim : (p.facing || 0) + Math.PI / 2;
          const spread = boneChannel ? 0.55 : 0.9;
          const squirtAng = boneChannel ? aim + rand(-spread, spread) : rand(-0.9, 0.9) + (p.facing || 0) + Math.PI / 2;
          const dist = rand(r * 0.35, r * 1.05) * (boneChannel ? 2.2 : 1);
          const sx = p.x + Math.cos(squirtAng) * dist * (boneChannel ? 0.95 : 0.55);
          const sy = p.y + Math.sin(squirtAng) * dist * (boneChannel ? 0.45 : 0.25) - (boneChannel ? rand(r * 0.25, r * 1.05) : 0);
          this.spawnBloodStain(sx, sy, rand(6, 13) * scale);
          const squirtN = boneChannel ? 9 : 4;
          for (let j = 0; j < squirtN; j++) {
            const a = squirtAng + rand(-0.45, 0.45);
            const spd = rand(40, 110) * (boneChannel ? 2.1 : 1);
            const lift = boneChannel ? rand(70, 165) : rand(10, 40);
            this.particles.push(new Particle(p.x + rand(-4, 4), p.y + r * 0.1,
              Math.cos(a) * spd, Math.sin(a) * spd * (boneChannel ? 0.25 : 0.35) - lift,
              rand(0.22, 0.42), j % 2 ? "#a01828" : "#6a0818", rand(1.2, 2.8) * scale,
              { kind: "dot", grav: boneChannel ? 115 : 140 }));
          }
        }
      }
    }

    // Exhaustion = sweat/rain: water droplets falling onto the warlock
    if (p.exhaustionT > 0) {
      c.save();
      for (let i = 0; i < 6; i++) {
        const ph = t * 5.2 + i * 0.95 + p.index * 0.61;
        const cycle = ph - Math.floor(ph);
        const lane = Math.sin(i * 1.9 + p.index * 0.4) * r * 0.62;
        const dropX = p.x + lane + Math.sin(ph * 4.2) * 2.5;
        const dropY = p.y - r * 1.05 + cycle * r * 1.75;
        const fade = cycle < 0.12 ? cycle / 0.12 : cycle > 0.88 ? (1 - cycle) / 0.12 : 1;
        const sz = 2.4 + (i % 3) * 0.55;
        c.globalAlpha = 0.18 + fade * 0.72;
        c.fillStyle = "rgba(120,190,255,0.92)";
        c.beginPath();
        c.ellipse(dropX, dropY, sz * 0.55, sz, 0, 0, TAU);
        c.fill();
        c.fillStyle = "rgba(220,245,255,0.9)";
        c.beginPath();
        c.arc(dropX - sz * 0.18, dropY - sz * 0.38, sz * 0.22, 0, TAU);
        c.fill();
        if (cycle > 0.72) {
          c.globalAlpha = (1 - cycle) * 2.2;
          c.fillStyle = "rgba(120,190,255,0.35)";
          c.beginPath();
          c.ellipse(dropX, dropY + sz * 0.55, sz * 0.9, sz * 0.28, 0, 0, TAU);
          c.fill();
        }
      }
      c.restore();
      if (this.state === "playing" && Math.random() < 0.38) {
        this.particles.push(new Particle(
          p.x + rand(-r * 0.65, r * 0.65), p.y - r * rand(0.75, 1.25),
          rand(-10, 10), rand(42, 92),
          rand(0.32, 0.58), Math.random() < 0.45 ? "#7ec0ff" : "#c8ecff",
          rand(1.6, 3.0), { kind: "dot", grav: 175 }));
      }
    }

    // Stunned = spinning glowing stars above the head
    if (p.stun > 0) {
      c.save();
      c.globalCompositeOperation = "lighter";
      for (let i = 0; i < 3; i++) {
        const a = t * 5 + i * (TAU / 3);
        const sx = p.x + Math.cos(a) * 11, sy = p.y - r - 9 + Math.sin(a) * 3.5;
        drawStar(c, sx, sy, 3.2, "rgba(255,224,137,0.95)");
      }
      c.restore();
    }

    // Charge / channel telegraphs (self, or sanctuary for teammates).
    if (p.channelProg > 0) {
      const me = this.human();
      const chId = p.channelSpell || p.loadout["2"] || "scourge";
      const showChannel = p === me || (chId === "sanctuary" && isTeammate(me, p.team)) || chId === "bonespear";
      if (showChannel) {
      const prog = clamp(p.channelProg, 0, 1);
      const chargeId = this.chargingSlot ? p.loadout[this.chargingSlot] : null;
      const chargeSp = chargeId ? SPELLS[chargeId] : null;
      if (chargeSp && chargeSp.type === "chargebeam") {
        c.save();
        c.globalCompositeOperation = "source-over";
        c.strokeStyle = "rgba(18,10,28,0.55)";
        c.globalAlpha = 0.3 + 0.35 * prog;
        c.lineWidth = 2;
        c.beginPath(); c.arc(p.x, p.y, r + 8 + prog * 4, 0, TAU); c.stroke();
        c.strokeStyle = "rgba(48,32,72,0.9)";
        c.globalAlpha = 0.95;
        c.lineWidth = 3;
        c.beginPath(); c.arc(p.x, p.y, r + 10, -Math.PI / 2, -Math.PI / 2 + TAU * prog); c.stroke();
        c.globalAlpha = 0.25 + 0.2 * prog;
        c.fillStyle = "rgba(6,3,12,0.5)";
        c.beginPath(); c.arc(p.x, p.y, r + 4, 0, TAU); c.fill();
        c.restore();
      } else if (chId === "bonespear") {
        const chSp = spellInfo(chId) || SPELLS.bonespear;
        const aim = p.aim != null ? p.aim : p.facing;
        const prad = r + 4;
        const spearR = chSp.radius || 10;
        const dist = prad * lerp(0.55, 1.0, prog);
        const sx = p.x + Math.cos(aim) * dist;
        const sy = p.y + Math.sin(aim) * dist;
        c.save();
        c.translate(sx, sy);
        c.globalAlpha = 0.55 + 0.45 * prog;
        this.upright();
        this.drawBoneSpear(c, spearR * lerp(0.85, 1.0, prog), aim);
        c.restore();
        // Flaying the arm: heavy blood squirts along the cast line while winding up
        if (this.state === "playing") {
          const armX = p.x + Math.cos(aim) * r * 0.15;
          const armY = p.y + Math.sin(aim) * r * 0.15;
          c.save();
          c.globalCompositeOperation = "source-over";
          for (let i = 0; i < 3; i++) {
            const ph = t * 9 + i * 1.35 + p.index;
            const burst = (Math.sin(ph) * 0.5 + 0.5) * prog;
            if (burst < 0.25) continue;
            const len = r * (1.05 + burst * 2.5);
            const spread = 0.22 + i * 0.08;
            const a0 = aim + rand(-spread, spread);
            const ex = armX + Math.cos(a0) * len;
            const ey = armY + Math.sin(a0) * len * 0.55 - burst * r * 0.95;
            c.strokeStyle = `rgba(140,12,24,${0.35 + burst * 0.45})`;
            c.lineWidth = 2.5 + burst * 4;
            c.lineCap = "round";
            c.beginPath();
            c.moveTo(armX, armY);
            c.quadraticCurveTo(
              armX + Math.cos(a0) * len * 0.45,
              armY + Math.sin(a0) * len * 0.2 - burst * r * 0.75,
              ex, ey);
            c.stroke();
            c.fillStyle = `rgba(180,20,32,${0.5 + burst * 0.35})`;
            c.beginPath();
            c.ellipse(ex, ey, 3.5 + burst * 5, 6 + burst * 8, a0, 0, TAU);
            c.fill();
          }
          c.restore();
          if (Math.random() < 0.55 * prog) {
            const squirtAng = aim + rand(-0.35, 0.35);
            const dist = rand(r * 1.1, r * 2.8);
            const sx = armX + Math.cos(squirtAng) * dist;
            const sy = armY + Math.sin(squirtAng) * dist * 0.45 - rand(r * 0.35, r * 1.25);
            this.spawnBloodStain(sx, sy, rand(14, 26) * (0.7 + prog * 0.5));
            for (let j = 0; j < 7; j++) {
              const a = squirtAng + rand(-0.5, 0.5);
              const spd = rand(120, 260);
              this.particles.push(new Particle(armX + rand(-6, 6), armY + rand(-6, 6),
                Math.cos(a) * spd, Math.sin(a) * spd * 0.22 - rand(85, 190),
                rand(0.28, 0.55), j % 2 ? "#b01828" : "#7a0818", rand(2.5, 5.5), { kind: "dot", grav: 115 }));
            }
          }
        }
      } else {
        const chSp = spellInfo(chId) || SPELLS.scourge;
        const isHeal = chId === "sanctuary";
        const col = chSp.color || (isHeal ? "#7ee8a0" : "#ff5d3a");
        const fillCol = isHeal ? "#c8ffd8" : "#ffd29a";
        const maxR = chSp.range || 165;
        c.save();
        c.translate(p.x, p.y);
        drawArmRangeTelegraph(c, maxR, prog, col, {
          fillCol, lineW: 3, dash: [6, 5], dashOffset: -t * 18,
        });
        drawArmChargeAccent(c, r, prog, col, fillCol, t);
        c.restore();
      }
      }
    }

    // Invisible (self) = faint shimmer ring so you can track yourself
    if (p.invisT > 0 && p === this.human()) {
      c.save();
      c.strokeStyle = `rgba(205,214,255,${0.25 + 0.15 * Math.sin(t * 4)})`;
      c.setLineDash([3, 5]); c.lineWidth = 1.5;
      c.beginPath(); c.arc(p.x, p.y, r + 6, 0, TAU); c.stroke();
      c.restore();
    }
  }

Game.prototype.drawTethers = function () {
    const c = this.ctx;
    for (const p of this.players) {
      if (!p.alive || p.falling || !p.tetherBy) continue;
      const a = p.tetherBy;
      if (!a.alive) continue;
      this.drawChainBetween(c, p.x, p.y, a.x, a.y, {
        light: "#d4c4a0", dark: "#6a5a40", width: 3.2, linkLen: 12,
      });
    }
  }

Game.prototype.spawnBloodStain = function (x, y, r) {
    if (!this.bloodStains) this.bloodStains = [];
    this.bloodStains.push({ x, y, r, t: 0, life: rand(4.5, 8) });
  };

Game.prototype.updateBloodStains = function (dt) {
    if (!this.bloodStains?.length) return;
    for (const st of this.bloodStains) st.t += dt;
    this.bloodStains = this.bloodStains.filter(st => st.t < st.life);
  };

Game.prototype.drawBloodStains = function () {
    const c = this.ctx;
    if (!this.bloodStains?.length) return;
    for (const st of this.bloodStains) {
      const p = clamp(st.t / st.life, 0, 1);
      const fade = 1 - p * p;
      const grow = lerp(0.75, 1.15, Math.min(p * 2.5, 1));
      const rx = st.r * grow;
      const ry = st.r * grow * 0.62;
      c.save();
      c.translate(st.x, st.y);
      c.globalAlpha = fade * 0.72;
      c.fillStyle = "#5a0810";
      c.beginPath(); c.ellipse(0, 0, rx, ry, 0, 0, TAU); c.fill();
      c.globalAlpha = fade * 0.45;
      c.fillStyle = "#8a1020";
      c.beginPath(); c.ellipse(0, 0, rx * 0.55, ry * 0.55, 0, 0, TAU); c.fill();
      c.globalAlpha = fade * 0.28;
      c.strokeStyle = "#3a0508";
      c.lineWidth = 1.2;
      c.beginPath(); c.ellipse(0, 0, rx * 0.92, ry * 0.92, 0, 0, TAU); c.stroke();
      c.restore();
    }
    c.globalAlpha = 1;
  };

/** Inferna Inferno Nova wind-up: expanding flame rings + charge arc (ground plane at entity feet). */
Game.prototype.drawBossJudgmentChannel = function (c, p, prog, accent = "#ffb060", core = "#ff6030") {
  const tt = this.nowS;
  const br = p.radius * 7.5;
  const pulse = 0.5 + 0.5 * Math.sin(tt * 11);
  const coreRgb = hexToRgb(core) || { r: 255, g: 100, b: 30 };
  const accentRgb = hexToRgb(accent) || { r: 255, g: 176, b: 96 };
  c.save();
  c.globalCompositeOperation = "lighter";
  c.fillStyle = `rgba(${coreRgb.r},${coreRgb.g},${coreRgb.b},${0.1 + prog * 0.2})`;
  c.beginPath(); c.arc(0, 0, br * (0.55 + prog * 0.45), 0, TAU); c.fill();
  for (let i = 0; i < 3; i++) {
    const ring = br * (0.45 + i * 0.22 + prog * 0.35);
    c.strokeStyle = `rgba(${coreRgb.r},${coreRgb.g},${coreRgb.b},${(0.4 + prog * 0.45) * (1 - i * 0.2)})`;
    c.lineWidth = 5 - i;
    c.beginPath(); c.arc(0, 0, ring, 0, TAU); c.stroke();
  }
  c.strokeStyle = `rgba(${accentRgb.r},${accentRgb.g},${accentRgb.b},${0.75 + 0.2 * pulse})`;
  c.lineWidth = 8;
  c.beginPath();
  c.arc(0, 0, br * 0.72, -Math.PI / 2, -Math.PI / 2 + TAU * prog);
  c.stroke();
  for (let i = 0; i < 8; i++) {
    const a = i / 8 * TAU + tt * 1.4;
    const len = br * (0.35 + prog * 0.55);
    c.strokeStyle = `rgba(${coreRgb.r},${coreRgb.g},${coreRgb.b},${0.3 + prog * 0.4})`;
    c.lineWidth = 3;
    c.beginPath();
    c.moveTo(Math.cos(a) * br * 0.15, Math.sin(a) * br * 0.15);
    c.lineTo(Math.cos(a) * len, Math.sin(a) * len);
    c.stroke();
  }
  c.restore();
  if (this.state === "playing" && Math.random() < 0.35 + prog * 0.4) {
    const a = rand(0, TAU);
    const dist = rand(br * 0.2, br * 0.85);
    this.particles.push(new Particle(
      p.x + Math.cos(a) * dist, p.y + Math.sin(a) * dist,
      rand(-30, 30), rand(-80, -20),
      rand(0.35, 0.7), Math.random() < 0.5 ? accent : core, rand(4, 9), { kind: "glow" }));
  }
};

/** Aurelion rotating lethal beam wedges (world space). */
Game.prototype.drawBossBeams = function () {
  const c = this.ctx;
  const t = this.nowS;
  const beams = this.bossBeams || [];
  if (!beams.length) return;

  const wedgePath = (ang, halfW, inner, reach) => {
    c.beginPath();
    c.moveTo(Math.cos(ang - halfW) * inner, Math.sin(ang - halfW) * inner);
    c.arc(0, 0, reach, ang - halfW, ang + halfW);
    c.lineTo(Math.cos(ang + halfW) * inner, Math.sin(ang + halfW) * inner);
    c.arc(0, 0, inner, ang + halfW, ang - halfW, true);
    c.closePath();
  };

  for (const b of beams) {
    const inner = b.inner || 70;
    const reach = b.reach || this.platformRadius || 400;
    const ang = b.angle || 0;
    const hw = b.halfW || 0.17;
    const armT = b.armT || 0;
    const arming = armT > 0;
    const warnAng = ang + (b.warnLead || 0);
    const warnW = b.warnW || 0.11;
    const pulse = 0.5 + 0.5 * Math.sin(t * 6 + ang * 2);
    const armPulse = arming ? 0.35 + 0.65 * (1 - armT / 1.7) : pulse;
    const cx = b.x, cy = b.y;

    c.save();
    c.translate(cx, cy);

    if (arming) {
      c.save();
      wedgePath(ang, hw, inner, reach);
      c.fillStyle = `rgba(255,220,140,${0.12 + 0.18 * armPulse})`;
      c.fill();
      c.strokeStyle = `rgba(255,240,200,${0.35 + 0.45 * armPulse})`;
      c.lineWidth = 2.5;
      c.stroke();
      c.globalCompositeOperation = "lighter";
      c.strokeStyle = `rgba(255,200,80,${0.25 + 0.35 * armPulse})`;
      c.lineWidth = 6;
      c.beginPath();
      c.arc(0, 0, reach, ang - hw, ang + hw);
      c.stroke();
      c.restore();
      c.restore();
      continue;
    }

    // warning telegraph — cool gold shimmer ahead of the lethal wedge
    c.save();
    wedgePath(warnAng, warnW, inner, reach);
    c.fillStyle = `rgba(180,210,255,${0.06 + 0.05 * pulse})`;
    c.fill();
    c.strokeStyle = `rgba(255,230,160,${0.22 + 0.15 * pulse})`;
    c.lineWidth = 1.5;
    c.stroke();
    c.restore();

    // soft outer feather
    c.save();
    wedgePath(ang, hw * 1.22, inner, reach);
    c.fillStyle = `rgba(255,140,40,${0.06 + 0.04 * pulse})`;
    c.fill();
    c.restore();

    // lethal core — radial falloff along the wedge
    c.save();
    wedgePath(ang, hw, inner, reach);
    c.clip();
    const lg = c.createLinearGradient(
      Math.cos(ang) * inner, Math.sin(ang) * inner,
      Math.cos(ang) * reach, Math.sin(ang) * reach,
    );
    lg.addColorStop(0, `rgba(255,248,220,${0.12 + 0.08 * pulse})`);
    lg.addColorStop(0.12, `rgba(255,210,90,${0.38 + 0.18 * pulse})`);
    lg.addColorStop(0.55, `rgba(255,150,45,${0.32 + 0.14 * pulse})`);
    lg.addColorStop(1, "rgba(180,60,15,0.04)");
    c.fillStyle = lg;
    c.fillRect(-reach, -reach, reach * 2, reach * 2);

    // inner scan lines (subtle motion)
    c.globalCompositeOperation = "lighter";
    c.strokeStyle = `rgba(255,255,220,${0.08 + 0.06 * pulse})`;
    c.lineWidth = 1;
    const lines = 5;
    for (let i = 0; i < lines; i++) {
      const r = inner + (reach - inner) * ((i + 0.5 + (t * 0.35) % 1) / lines);
      c.beginPath();
      c.arc(0, 0, r, ang - hw * 0.92, ang + hw * 0.92);
      c.stroke();
    }
    c.restore();

    // leading edge highlight
    c.save();
    wedgePath(ang, hw, inner, reach);
    c.strokeStyle = `rgba(255,255,240,${0.55 + 0.35 * pulse})`;
    c.lineWidth = 2.5;
    c.stroke();
    c.strokeStyle = `rgba(255,180,60,${0.35 + 0.2 * pulse})`;
    c.lineWidth = 5;
    c.globalCompositeOperation = "lighter";
    c.beginPath();
    c.arc(0, 0, reach, ang - hw, ang + hw);
    c.stroke();
    c.restore();

    // emitter bloom at the inner safe radius
    c.globalCompositeOperation = "lighter";
    const bloom = c.createRadialGradient(0, 0, 0, 0, 0, inner * 1.2);
    bloom.addColorStop(0, `rgba(255,235,180,${0.55 + 0.25 * pulse})`);
    bloom.addColorStop(0.55, "rgba(255,180,60,0.18)");
    bloom.addColorStop(1, "rgba(255,140,30,0)");
    c.fillStyle = bloom;
    c.beginPath(); c.arc(0, 0, inner * 1.2, 0, TAU); c.fill();

    c.restore();
  }
};

/** Vorathal Shatter wind-up — ice charge rings (ground plane at entity feet). */
Game.prototype.drawBossShatterChannel = function (c, p, prog) {
  const tt = this.nowS;
  const br = p.radius * 7.5;
  const pulse = 0.5 + 0.5 * Math.sin(tt * 9);
  c.save();
  c.globalCompositeOperation = "lighter";
  c.fillStyle = `rgba(168,212,240,${0.08 + prog * 0.18})`;
  c.beginPath(); c.arc(0, 0, br * (0.55 + prog * 0.45), 0, TAU); c.fill();
  for (let i = 0; i < 3; i++) {
    const ring = br * (0.45 + i * 0.22 + prog * 0.35);
    c.strokeStyle = `rgba(${160 + i * 15},${220 + i * 8},255,${(0.35 + prog * 0.4) * (1 - i * 0.2)})`;
    c.lineWidth = 5 - i;
    c.beginPath(); c.arc(0, 0, ring, 0, TAU); c.stroke();
  }
  c.strokeStyle = `rgba(232,244,255,${0.7 + 0.2 * pulse})`;
  c.lineWidth = 7;
  c.beginPath();
  c.arc(0, 0, br * 0.72, -Math.PI / 2, -Math.PI / 2 + TAU * prog);
  c.stroke();
  c.restore();
};

/** Frost-crack warning on heroes vulnerable to Shatter during windup. */
Game.prototype.drawShatterVulnerabilityOverlay = function (c, p) {
  if (!p?.alive || p.falling) return;
  const boss = this.players.find(pl => pl.boss === "vorathal" && pl.alive);
  if (!boss || boss.channelSpell !== "boss_shatter") return;
  const frozen = (p.freeze || 0) > 0 || (p.root || 0) > 0;
  let vulnerable = frozen;
  if (p.isHuman) {
    const pred = this.pred?.init ? this.pred : p;
    const vel = Math.hypot(pred.vx || 0, pred.vy || 0);
    const moving = pred.moveTarget || p.moveTarget;
    if (!moving && vel < 80) vulnerable = true;
  }
  if (!vulnerable) return;
  const t = this.nowS;
  const pulse = 0.5 + 0.5 * Math.sin(t * 12);
  const br = p.radius + 12;
  c.save();
  c.globalCompositeOperation = "lighter";
  c.strokeStyle = `rgba(168,212,240,${0.65 + pulse * 0.3})`;
  c.lineWidth = 3;
  c.setLineDash([5, 4]);
  c.lineDashOffset = -t * 22;
  c.beginPath();
  c.arc(0, 0, br, 0, TAU);
  c.stroke();
  c.setLineDash([]);
  for (let i = 0; i < 4; i++) {
    const a = (i / 4) * TAU + t * 0.4;
    c.strokeStyle = `rgba(232,244,255,${0.5 + pulse * 0.25})`;
    c.lineWidth = 2;
    c.beginPath();
    c.moveTo(Math.cos(a) * br * 0.3, Math.sin(a) * br * 0.3);
    c.lineTo(Math.cos(a) * br * 0.95, Math.sin(a) * br * 0.95);
    c.stroke();
  }
  c.restore();
};

/** Kael Mirror Court — bright arcane ward while the real boss is immune. */
Game.prototype.drawMirrorCourtImmunityWard = function (c, p, layer) {
  const tt = this.nowS;
  const pulse = 0.72 + 0.28 * Math.sin(tt * 6);
  const br = p.radius + (layer === "ground" ? 34 : 30);

  if (layer === "ground") {
    const tilt = this.scale > 0 ? this.scaleY / this.scale : 0.62;
    c.save();
    c.globalCompositeOperation = "lighter";
    c.fillStyle = `rgba(168,104,232,${0.14 + 0.08 * Math.sin(tt * 5)})`;
    c.beginPath();
    c.ellipse(0, p.radius * 0.55, br * 1.15, br * 0.55, 0, 0, TAU);
    c.fill();
    c.scale(1, tilt);
    c.rotate(tt * 0.35);
    c.strokeStyle = `rgba(210,160,255,${0.55 + 0.25 * Math.sin(tt * 7)})`;
    c.lineWidth = 3.5;
    for (let t = 0; t < 2; t++) {
      c.beginPath();
      for (let i = 0; i < 3; i++) {
        const a = (i / 3) * TAU - Math.PI / 2 + t * Math.PI;
        const x = Math.cos(a) * br, y = Math.sin(a) * br * 0.72;
        i ? c.lineTo(x, y) : c.moveTo(x, y);
      }
      c.closePath();
      c.stroke();
    }
    c.setLineDash([10, 7]);
    c.lineDashOffset = -tt * 45;
    c.lineWidth = 2.5;
    c.strokeStyle = `rgba(235,220,255,${0.45 + 0.2 * Math.sin(tt * 9)})`;
    c.beginPath(); c.arc(0, 0, br * 1.08, 0, TAU); c.stroke();
    c.setLineDash([]);
    c.restore();
    return;
  }

  c.save();
  c.globalCompositeOperation = "lighter";
  const scalePulse = 1 + 0.05 * Math.sin(tt * 5);
  c.scale(scalePulse, scalePulse);

  if (layer === "body") {
    c.fillStyle = this.grad("mirrorCourtShield:" + br, c2 => {
      const bg = c2.createRadialGradient(0, 0, br * 0.25, 0, 0, br);
      bg.addColorStop(0, `rgba(210,170,255,${0.18 * pulse})`);
      bg.addColorStop(0.55, `rgba(168,104,232,${0.28 * pulse})`);
      bg.addColorStop(1, `rgba(120,60,200,${0.52 * pulse})`);
      return bg;
    });
    c.beginPath(); c.arc(0, 0, br, 0, TAU); c.fill();
    c.strokeStyle = `rgba(210,160,255,${0.75 + 0.2 * Math.sin(tt * 8)})`;
    c.lineWidth = 4.5;
    c.beginPath(); c.arc(0, 0, br, 0, TAU); c.stroke();
    c.strokeStyle = `rgba(255,240,255,${0.35 + 0.2 * Math.sin(tt * 11 + 0.6)})`;
    c.lineWidth = 2.5;
    c.setLineDash([7, 6]);
    c.beginPath(); c.arc(0, 0, br + 8, tt * 1.8, tt * 1.8 + Math.PI * 1.4); c.stroke();
    c.setLineDash([]);
    c.strokeStyle = `rgba(201,160,255,${0.45 * pulse})`; c.lineWidth = 1.5;
    c.beginPath();
    for (let i = 0; i < 6; i++) {
      const a = i / 6 * TAU + tt * 0.7;
      c.moveTo(Math.cos(a) * (br - 6), Math.sin(a) * (br - 6));
      c.lineTo(Math.cos(a) * (br + 4), Math.sin(a) * (br + 4));
    }
    c.stroke();
    for (let arc = 0; arc < 2; arc++) {
      const sa = tt * (2.2 + arc * 0.7) % TAU;
      c.strokeStyle = `rgba(255,245,255,${0.85 - arc * 0.15})`; c.lineWidth = 4 - arc;
      c.beginPath(); c.arc(0, 0, br - 2, sa, sa + 1.1); c.stroke();
    }
  } else {
    c.strokeStyle = `rgba(255,245,255,${0.8 + 0.15 * Math.sin(tt * 10)})`;
    c.lineWidth = 5;
    c.beginPath(); c.arc(0, 0, br + 2, 0, TAU); c.stroke();
    c.strokeStyle = `rgba(168,104,232,${0.55 * pulse})`;
    c.lineWidth = 2;
    c.beginPath(); c.arc(0, 0, br + 10, tt * 2.5, tt * 2.5 + Math.PI * 0.9); c.stroke();
  }
  c.restore();
};

/** Floating ability name when a boss fires an instant cast (Putrid Spew, Trample, …). */
Game.prototype.drawBossCastLabel = function (c, p) {
  const sp = SPELLS[p.castLabel];
  if (!sp) return;
  const label = sp.name || p.castLabel;
  const col = sp.color || "#c8d040";
  const yOff = p.boss === "kael" ? p.radius * 9.5 : p.radius * 10.5;
  const pulse = 0.85 + 0.15 * Math.sin(this.nowS * 8);
  const px = Math.round(Math.max(14, 18 / this.scale));
  c.save();
  c.globalAlpha = pulse;
  c.font = `700 ${px}px sans-serif`;
  c.textAlign = "center";
  c.textBaseline = "bottom";
  c.strokeStyle = "rgba(0,0,0,0.75)";
  c.lineWidth = Math.max(3, px * 0.22);
  c.strokeText(label.toUpperCase(), 0, -yOff - p.radius * 0.8);
  c.fillStyle = col;
  c.fillText(label.toUpperCase(), 0, -yOff - p.radius * 0.8);
  c.restore();
};

/** Kael Spatial Swap — tether + target marker during windup. */
Game.prototype.drawKaelSpatialSwapTelegraph = function () {
  const boss = this.players.find(p => p.boss === "kael" && p.alive && !p.bossAdd && p.channelSpell === "boss_spatial_swap");
  if (!boss) return;
  let target = null;
  let best = -1;
  for (const pl of this.players) {
    if (!pl.isHuman || !pl.alive || pl.falling) continue;
    const d = Math.hypot(pl.x - boss.x, pl.y - boss.y);
    if (d > best) { best = d; target = pl; }
  }
  if (!target) return;
  const c = this.ctx;
  const prog = clamp(boss.channelProg || 0, 0, 1);
  const pulse = 0.55 + 0.45 * Math.sin(this.nowS * 11);
  c.save();
  c.globalCompositeOperation = "lighter";
  c.strokeStyle = `rgba(200,140,255,${0.35 + prog * 0.45})`;
  c.lineWidth = 2.5 + prog * 2;
  c.setLineDash([10, 8]);
  c.lineDashOffset = -this.nowS * 60;
  c.beginPath();
  c.moveTo(boss.x, boss.y);
  c.lineTo(target.x, target.y);
  c.stroke();
  c.setLineDash([]);
  c.strokeStyle = `rgba(240,200,255,${pulse * (0.5 + prog * 0.4)})`;
  c.lineWidth = 3;
  c.beginPath();
  c.arc(target.x, target.y, target.radius + 16 + prog * 8, 0, TAU);
  c.stroke();
  c.fillStyle = `rgba(160,90,230,${0.12 + prog * 0.15})`;
  c.beginPath();
  c.arc(target.x, target.y, target.radius + 10, 0, TAU);
  c.fill();
  c.restore();
};
